{
  "about.blocks": "Denetlenen sunucular",
  "about.contact": "İletişim:",
  "about.default_locale": "Varsayılan",
  "about.disclaimer": "Mastodon özgür, açık kaynak bir yazılımdır ve Mastodon gGmbH şirketinin ticari markasıdır.",
  "about.domain_blocks.no_reason_available": "Gerekçe mevcut değil",
  "about.domain_blocks.preamble": "Mastodon, genel olarak fediverse'teki herhangi bir sunucudan içerik görüntülemenize ve kullanıcılarıyla etkileşim kurmanıza izin verir. Bunlar, bu sunucuda yapılmış olan istisnalardır.",
  "about.domain_blocks.silenced.explanation": "Açık bir şekilde aramadığınız veya takip ederek abone olmadığınız sürece, bu sunucudaki profilleri veya içerikleri genelde göremeyeceksiniz.",
  "about.domain_blocks.silenced.title": "Sınırlı",
  "about.domain_blocks.suspended.explanation": "Bu sunucudaki hiçbir veri işlenmeyecek, saklanmayacak veya değiş tokuş edilmeyecektir, dolayısıyla bu sunucudaki kullanıcılarla herhangi bir etkileşim veya iletişim imkansız olacaktır.",
  "about.domain_blocks.suspended.title": "Askıya alındı",
  "about.language_label": "Dil",
  "about.not_available": "Bu sunucuda bu bilgi kullanıma sunulmadı.",
  "about.powered_by": "{mastodon} destekli merkeziyetsiz sosyal ağ",
  "about.rules": "Sunucu kuralları",
  "account.account_note_header": "Kişisel not",
  "account.activity": "Aktivite",
  "account.add_note": "Kişisel bir not ekle",
  "account.add_or_remove_from_list": "Listelere ekle veya kaldır",
  "account.badges.admin": "Yönetici",
  "account.badges.blocked": "Engellendi",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Engellenen alan adı",
  "account.badges.group": "Grup",
  "account.badges.muted": "Sessize Alındı",
  "account.badges.muted_until": "{until} tarihine kadar sessize alınmış",
  "account.block": "@{name} adlı kişiyi engelle",
  "account.block_domain": "{domain} alan adını engelle",
  "account.block_short": "Engelle",
  "account.blocked": "Engellendi",
  "account.cancel_follow_request": "Takibi bırak",
  "account.copy": "Profil bağlantısını kopyala",
  "account.direct": "@{name} kullanıcısından özel olarak bahset",
  "account.disable_notifications": "@{name} kişisinin gönderi bildirimlerini kapat",
  "account.edit_note": "Kişisel notu düzenle",
  "account.edit_profile": "Profili düzenle",
  "account.edit_profile_short": "Düzenle",
  "account.enable_notifications": "@{name} kişisinin gönderi bildirimlerini aç",
  "account.endorse": "Profilimde öne çıkar",
  "account.familiar_followers_many": "{name1}, {name2}, {othersCount, plural, one {# diğer} other {# diğer}} bildiğiniz kişi tarafından takip ediliyor",
  "account.familiar_followers_one": "{name1} tarafından takip ediliyor",
  "account.familiar_followers_two": "{name1} ve {name2} tarafından takip ediliyor",
  "account.featured": "Öne çıkan",
  "account.featured.accounts": "Profiller",
  "account.featured.collections": "Koleksiyonlar",
  "account.featured.new_collection": "Yeni koleksiyon",
  "account.field_overflow": "Tüm içeriği göster",
  "account.filters.all": "Tüm aktiviteler",
  "account.filters.boosts_toggle": "Yeniden paylaşımları göster",
  "account.filters.posts_boosts": "Gönderiler ve yeniden paylaşımlar",
  "account.filters.posts_only": "Gönderiler",
  "account.filters.posts_replies": "Gönderiler ve yanıtlar",
  "account.filters.replies_toggle": "Yanıtları göster",
  "account.follow": "Takip et",
  "account.follow_back": "Geri takip et",
  "account.follow_back_short": "Geri takip et",
  "account.follow_request": "Takip isteği gönder",
  "account.follow_request_cancel": "İsteği iptal et",
  "account.follow_request_cancel_short": "İptal",
  "account.follow_request_short": "İstek",
  "account.followers": "Takipçi",
  "account.followers.empty": "Henüz kimse bu kullanıcıyı takip etmiyor.",
  "account.followers_counter": "{count, plural, one {{counter} takipçi} other {{counter} takipçi}}",
  "account.followers_you_know_counter": "bildiğiniz {counter}",
  "account.following": "Takip Ediliyor",
  "account.following_counter": "{count, plural, one {{counter} takip edilen} other {{counter} takip edilen}}",
  "account.follows.empty": "Bu kullanıcı henüz kimseyi takip etmiyor.",
  "account.follows_you": "Seni takip ediyor",
  "account.go_to_profile": "Profile git",
  "account.hide_reblogs": "@{name} kullanıcısının yeniden paylaşımlarını gizle",
  "account.in_memoriam": "Hatırasına.",
  "account.join_modal.day": "Gün",
  "account.join_modal.me": "{server} sunucusuna katıldığınız tarih",
  "account.join_modal.me_anniversary": "Fediverse Yıldönümünüz kutlu olsun! {server} sunucusuna katıldığınız tarih",
  "account.join_modal.me_today": "{server} sunucusunda ilk gününüz!",
  "account.join_modal.other": "{name}, {server} sunucusuna katıldığı tarih",
  "account.join_modal.other_today": "{name} kişisinin {server} sunucusunda ilk günü!",
  "account.join_modal.share.celebrate": "Kutlama amaçlı bir paylaşım yapın",
  "account.join_modal.share.intro": "Tanıtım için bir paylaşım yapın",
  "account.join_modal.share.welcome": "Bir hoş geldiniz paylaşımı yapın",
  "account.join_modal.years": "{number, plural, one {yıl} other {yıl}}",
  "account.joined_short": "Katıldı",
  "account.languages": "Abone olunan dilleri değiştir",
  "account.last_active": "Son etkin",
  "account.link_verified_on": "Bu bağlantının sahipliği {date} tarihinde denetlendi",
  "account.locked_info": "Bu hesabın gizlilik durumu gizli olarak ayarlanmış. Sahibi, onu kimin takip edebileceğini elle onaylıyor.",
  "account.media": "Medya",
  "account.mention": "@{name} kişisinden bahset",
  "account.menu.add_to_list": "Listeye ekle…",
  "account.menu.block": "Hesabı engelle",
  "account.menu.block_domain": "{domain} alan adını engelle",
  "account.menu.copied": "Hesap bağlantısı panoya kopyalandı",
  "account.menu.copy": "Bağlantıyı kopyala",
  "account.menu.direct": "Özel olarak bahset",
  "account.menu.hide_reblogs": "Zaman çizelgesinde yeniden gönderimleri gizle",
  "account.menu.mention": "Bahset",
  "account.menu.mute": "Hesabı sessize al",
  "account.menu.note.description": "Sadece sizin tarafınızdan görülebilir",
  "account.menu.open_original_page": "{domain} alan adında görüntüle",
  "account.menu.remove_follower": "Takipçiyi kaldır",
  "account.menu.report": "Hesabı bildir",
  "account.menu.share": "Paylaş…",
  "account.menu.show_reblogs": "Zaman çizelgesinde yeniden gönderimleri göster",
  "account.menu.unblock": "Hesabın engelini kaldır",
  "account.menu.unblock_domain": "{domain} alan adının engelini kaldır",
  "account.menu.unmute": "Hesabın sessizliğini kaldır",
  "account.moved_to": "{name} yeni hesabının artık şu olduğunu belirtti:",
  "account.mute": "@{name} adlı kişiyi sessize al",
  "account.mute_notifications_short": "Bildirimleri sessize al",
  "account.mute_short": "Sessize al",
  "account.muted": "Susturuldu",
  "account.mutual": "Birbirinizi takip ediyorsunuz",
  "account.name.copy": "Kullanıcı kimliğini kopyala",
  "account.name.help.domain": "{domain} kullanıcının profilini ve gönderilerini barındıran sunucudur.",
  "account.name.help.domain_self": "{domain} profilinizi ve gönderilerinizi barındıran sunucunuzdur.",
  "account.name.help.footer": "Tıpkı farklı e-posta sağlayıcılarını kullanan kişilere e-posta gönderebileceğiniz gibi, diğer Mastodon sunucularındaki kullanıcılarla ve diğer Fediverse uygulamalarındaki herkesle etkileşim kurabilirsiniz.",
  "account.name.help.header": "Bir kullanıcı kimliği, e-posta adresi gibidir",
  "account.name.help.username": "{username} bu hesabın sunucudaki kullanıcı adıdır. Başka bir sunucudaki başka bir kişi de aynı kullanıcı adına sahip olabilir.",
  "account.name.help.username_self": "{username} bu sunucudaki kullanıcı adınızdır. Başka bir sunucudaki başka bir kullanıcı da aynı kullanıcı adına sahip olabilir.",
  "account.name_info": "Bu ne anlama geliyor?",
  "account.no_bio": "Herhangi bir açıklama belirtilmedi.",
  "account.node_modal.callout": "Kişisel notları sadece siz görüntüleyebilirsiniz.",
  "account.node_modal.edit_title": "Kişisel notu düzenle",
  "account.node_modal.error_unknown": "Not kaydedilemiyor",
  "account.node_modal.field_label": "Kişisel Not",
  "account.node_modal.save": "Kaydet",
  "account.node_modal.title": "Kişisel bir not ekle",
  "account.note.edit_button": "Düzenle",
  "account.note.title": "Kişisel not (sadece siz görüntüleyebilirsiniz)",
  "account.open_original_page": "Asıl sayfayı aç",
  "account.pending": "Beklemede",
  "account.posts": "Gönderiler",
  "account.remove_from_followers": "{name} takipçilerinden kaldır",
  "account.report": "@{name} adlı kişiyi bildir",
  "account.requested_follow": "{name} size takip isteği gönderdi",
  "account.share": "@{name} adlı kişinin profilini paylaş",
  "account.show_reblogs": "@{name} kişisinin yeniden paylaşımlarını göster",
  "account.statuses_counter": "{count, plural, one {{counter} gönderi} other {{counter} gönderi}}",
  "account.timeline.pinned": "Sabitlendi",
  "account.timeline.pinned.view_all": "Tüm sabitlenmiş gönderileri görüntüle",
  "account.unblock": "@{name} adlı kişinin engelini kaldır",
  "account.unblock_domain": "{domain} alan adının engelini kaldır",
  "account.unblock_domain_short": "Engeli kaldır",
  "account.unblock_short": "Engeli kaldır",
  "account.unendorse": "Profilimde öne çıkarma",
  "account.unfollow": "Takibi bırak",
  "account.unmute": "@{name} adlı kişinin sesini aç",
  "account.unmute_notifications_short": "Bildirimlerin sesini aç",
  "account.unmute_short": "Susturmayı kaldır",
  "account_edit.advanced_settings.bot_hint": "Bu hesap temelde otomatik eylemler gerçekleştirir ve izlenmeyebiliri diğerlerine bildir",
  "account_edit.advanced_settings.bot_label": "Otomatik hesap",
  "account_edit.advanced_settings.title": "Gelişmiş ayarlar",
  "account_edit.bio.add_label": "Biyografi ekle",
  "account_edit.bio.edit_label": "Biyografiyi düzenle",
  "account_edit.bio.placeholder": "Diğerlerinin sizi tanımasına yardımcı olmak için kısa bir tanıtım ekleyin.",
  "account_edit.bio.title": "Biyografi",
  "account_edit.bio_modal.add_title": "Biyografi ekle",
  "account_edit.bio_modal.edit_title": "Biyografiyi düzenle",
  "account_edit.column_button": "Tamam",
  "account_edit.column_title": "Profili Düzenle",
  "account_edit.custom_fields.add_label": "Alan ekle",
  "account_edit.custom_fields.edit_label": "Alanı düzenle",
  "account_edit.custom_fields.placeholder": "Hitaplarınızı, dış bağlantılarınızı veya paylaşmak istediğiniz herhangi bir şeyi ekleyin.",
  "account_edit.custom_fields.reorder_button": "Alanları sırala",
  "account_edit.custom_fields.tip_content": "Sahip olduğunuz web sitelerine bağlantıları doğrulayarak Mastodon hesabınıza kolayca güvenilirlik katabilirsiniz.",
  "account_edit.custom_fields.tip_title": "İpucu: Doğrulanmış bağlantılar ekleme",
  "account_edit.custom_fields.title": "Özel alanlar",
  "account_edit.custom_fields.verified_hint": "Doğrulanmış bir bağlantı nasıl eklerim?",
  "account_edit.display_name.add_label": "Görüntülenecek ad ekle",
  "account_edit.display_name.edit_label": "Görüntülenecek adı düzenle",
  "account_edit.display_name.placeholder": "Görünen adınız profilinizde ve zaman akışlarında adınızın nasıl göründüğüdür.",
  "account_edit.display_name.title": "Görünen ad",
  "account_edit.featured_hashtags.edit_label": "Etiket ekle",
  "account_edit.featured_hashtags.placeholder": "Başkalarının favori konularınızı tanımlamasına ve bunlara hızlı bir şekilde erişmesine yardımcı olun.",
  "account_edit.featured_hashtags.title": "Öne çıkan etiketler",
  "account_edit.field_actions.delete": "Alanı sil",
  "account_edit.field_actions.edit": "Alanı düzenle",
  "account_edit.field_delete_modal.confirm": "Bu özel alanı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
  "account_edit.field_delete_modal.delete_button": "Sil",
  "account_edit.field_delete_modal.title": "Özel alanı sil?",
  "account_edit.field_edit_modal.add_title": "Özel alan ekle",
  "account_edit.field_edit_modal.discard_confirm": "Yoksay",
  "account_edit.field_edit_modal.discard_message": "Kaydedilmemiş değişiklikleriniz var. Bunları silmek istediğinizden emin misiniz?",
  "account_edit.field_edit_modal.edit_title": "Özel alanı düzenle",
  "account_edit.field_edit_modal.length_warning": "Önerilen karakter sınırı aşıldı. Mobil kullanıcılar sahayı tam olarak görmeyebilirler.",
  "account_edit.field_edit_modal.link_emoji_warning": "Url'lerle birlikte özel emoji kullanmamanızı öneririz. Her ikisini de içeren özel alanlar, kullanıcıların kafasını karıştırmamak için bağlantı yerine yalnızca metin olarak görüntülenir.",
  "account_edit.field_edit_modal.name_hint": "Ör. \"Kişisel web sitesi\"",
  "account_edit.field_edit_modal.name_label": "Etiket",
  "account_edit.field_edit_modal.url_warning": "Bağlantı eklemek için lütfen başlangıca {protocol} ekleyin.",
  "account_edit.field_edit_modal.value_hint": "Ör. “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Değer",
  "account_edit.field_reorder_modal.drag_cancel": "Sürükleme iptal edildi. \"{item}\" alanı bırakıldı.",
  "account_edit.field_reorder_modal.drag_end": "\"{item}\" alanı bırakıldı.",
  "account_edit.field_reorder_modal.drag_instructions": "Özel alanları yeniden düzenlemek için boşluk tuşuna veya Enter tuşuna basın. Sürüklerken, ok tuşlarını kullanarak alanı yukarı veya aşağı taşıyın. Alanı yeni konumuna bırakmak için boşluk tuşuna veya Enter tuşuna tekrar basın veya iptal etmek için Escape tuşuna basın.",
  "account_edit.field_reorder_modal.drag_move": "\"{item}\" alanı hareket ettirildi.",
  "account_edit.field_reorder_modal.drag_over": "\"{item}\" alanı \"{over}\" üzerine hareket ettirildi.",
  "account_edit.field_reorder_modal.drag_start": "\"{item}\" alanı seçildi.",
  "account_edit.field_reorder_modal.handle_label": "\"{item}\" alanını sürükle",
  "account_edit.field_reorder_modal.title": "Alanları yeniden düzenle",
  "account_edit.image_alt_modal.add_title": "Alternatif metin ekle",
  "account_edit.image_alt_modal.details_content": "Yapılması gerekenler: <ul><li>Kendinizi resimdeki gibi tanımlayın</li><li>Üçüncü şahıs zamirleri kullanın (ör. “ben” yerine “Alex”)</li><li>Kısa ve öz olun – genellikle birkaç kelime yeterlidir</li></ul>Yapılmaması gerekenler:<ul><li>“Fotoğrafında” ifadesiyle başlamayın – bu, ekran okuyucular için gereksizdir</li></ul>Örnek:<ul><li>\"Yeşil gömlek ve gözlük takan Alex</li></ul>",
  "account_edit.image_alt_modal.details_title": "İpuçları: Profil fotoğrafları için alternatif metinler",
  "account_edit.image_alt_modal.edit_title": "Alternatif metni düzenle",
  "account_edit.image_alt_modal.text_hint": "Alternatif metin ekran okuyucu kullanan kullanıcıların içeriği anlamasına yardımcı olur.",
  "account_edit.image_alt_modal.text_label": "Alternatif metin",
  "account_edit.image_delete_modal.confirm": "Bu görseli silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
  "account_edit.image_delete_modal.delete_button": "Sil",
  "account_edit.image_delete_modal.title": "Resim silinsin mi?",
  "account_edit.image_edit.add_button": "Görsel ekle",
  "account_edit.image_edit.alt_add_button": "Alternatif metin ekle",
  "account_edit.image_edit.alt_edit_button": "Alternatif metni düzenle",
  "account_edit.image_edit.remove_button": "Görseli kaldır",
  "account_edit.image_edit.replace_button": "Görseli değiştir",
  "account_edit.item_list.delete": "{name} sil",
  "account_edit.item_list.edit": "{name} düzenle",
  "account_edit.name_modal.add_title": "Görünen ad ekle",
  "account_edit.name_modal.edit_title": "Görünen adı düzenle",
  "account_edit.profile_tab.button_label": "Özelleştir",
  "account_edit.profile_tab.hint.description": "Bu ayarlar kullanıcıların resmi uygulamalarda {server} üzerinde gördüklerini özelleştirir, ancak diğer sunuculardaki ve üçüncü taraf uygulamalardaki kullanıcılar için geçerli olmayabilir.",
  "account_edit.profile_tab.hint.title": "Görünümler yine de farklı olabilir",
  "account_edit.profile_tab.show_featured.description": "\"Öne Çıkanlar\" diğer hesapları sergileyebileceğiniz isteğe bağlı bir sekmedir.",
  "account_edit.profile_tab.show_featured.title": "\"Öne Çıkanlar\" sekmesini göster",
  "account_edit.profile_tab.show_media.description": "\"Medya\" resim veya video içeren gönderilerinizi gösteren isteğe bağlı bir sekmedir.",
  "account_edit.profile_tab.show_media.title": "\"Medya\" sekmesini göster",
  "account_edit.profile_tab.show_media_replies.description": "Etkinleştirildiğinde Medya sekmesi hem kendi gönderilerinizi hem de diğer kişilerin gönderilerine verdiğiniz yanıtları gösterir.",
  "account_edit.profile_tab.show_media_replies.title": "\"Medya\" sekmesinde yanıtları göster",
  "account_edit.profile_tab.show_relations.description": "Profilinizde takip ettiğiniz hesapları ve sizi takip eden kullanıcıları gösterir. Diğer kullanıcılar, sizin onları takip edip etmediğinizi yine de görebileceklerdir.",
  "account_edit.profile_tab.show_relations.title": "'Takipçilerimi' ve 'Takip Ettiklerimi' Göster",
  "account_edit.profile_tab.subtitle": "Profilinizin görüntülenme şeklini özelleştirin.",
  "account_edit.profile_tab.title": "Profil görüntüleme ayarları",
  "account_edit.save": "Kaydet",
  "account_edit.upload_modal.back": "Geri",
  "account_edit.upload_modal.done": "Tamamlandı",
  "account_edit.upload_modal.next": "İleri",
  "account_edit.upload_modal.step_crop.zoom": "Yakınlaştır",
  "account_edit.upload_modal.step_upload.button": "Dosyalara göz at",
  "account_edit.upload_modal.step_upload.dragging": "Yüklemek için bırakın",
  "account_edit.upload_modal.step_upload.header": "Bir resim seç",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF veya JPG formatında, en fazla {limit} MB.{br}Görsel {width}x{height} piksel boyutuna getirilir.",
  "account_edit.upload_modal.title_add.avatar": "Profil fotoğrafı ekle",
  "account_edit.upload_modal.title_add.header": "Kapak fotoğrafı ekle",
  "account_edit.upload_modal.title_replace.avatar": "Profil fotoğrafını değiştir",
  "account_edit.upload_modal.title_replace.header": "Kapak fotoğrafını değiştirin",
  "account_edit.verified_modal.details": "Kişisel web sitelerine bağlantıları doğrulayarak Mastodon profilinize güvenilirlik katın. İşte böyle çalışıyor:",
  "account_edit.verified_modal.invisible_link.details": "Bağlantıyı sitenizin header kısmına ekleyin. Önemli olan kısım, kullanıcı tarafından oluşturulan içeriğe sahip web sitelerinde kimlik sahtekarlığını önleyen rel=\"me\" özniteliğidir. {tag} yerine sayfanın başlığında bir bağlantı etiketi bile kullanabilirsiniz, ancak HTML, JavaScript çalıştırılmadan erişilebilir olmalıdır.",
  "account_edit.verified_modal.invisible_link.summary": "Bağlantıyı nasıl görünmez hale getirebilirim?",
  "account_edit.verified_modal.step1.header": "Aşağıdaki HTML kodunu kopyalayın ve web sitenizin header kısmına yapıştırın",
  "account_edit.verified_modal.step2.details": "Web sitenizi özel alan olarak zaten eklediyseniz, doğrulamayı tetiklemek için onu silip yeniden eklemeniz gerekir.",
  "account_edit.verified_modal.step2.header": "Web sitenizi özel bir alan olarak ekleyin",
  "account_edit.verified_modal.title": "Doğrulanmış bir bağlantı nasıl eklenir",
  "account_edit_tags.add_tag": "#{tagName} ekle",
  "account_edit_tags.column_title": "Etiketleri Düzenle",
  "account_edit_tags.help_text": "Öne çıkan etiketler kullanıcıların profilinizi keşfetmesine ve etkileşim kurmasına yardımcı olur. Profil sayfanızın Etkinlik görünümünde filtreler olarak görünürler.",
  "account_edit_tags.max_tags_reached": "Azami öne çıkan etiket sayısına ulaştınız.",
  "account_edit_tags.search_placeholder": "Bir etiket girin…",
  "account_edit_tags.suggestions": "Öneriler:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# gönderi} other {# gönderi}}",
  "account_list.hidden_notice": "Bu liste yalnızca sizin tarafınızdan görülebilir. Bu listeyi başkalarına göstermek için <link>{page} > {modal} > {field}</link> adresine gidin.",
  "account_list.total": "{total, plural, one {# hesap} other {# hesap}}",
  "account_note.placeholder": "Not eklemek için tıklayın",
  "admin.dashboard.daily_retention": "Kayıttan sonra günlük kullanıcı saklama oranı",
  "admin.dashboard.monthly_retention": "Kayıttan sonra aylık kullanıcı saklama oranı",
  "admin.dashboard.retention.average": "Ortalama",
  "admin.dashboard.retention.cohort": "Kayıt ayı",
  "admin.dashboard.retention.cohort_size": "Yeni kullanıcılar",
  "admin.impact_report.instance_accounts": "Bunun tarafından silinecek hesap profilleri",
  "admin.impact_report.instance_followers": "Kullanıcılarımızın kaybedeceği takipçiler",
  "admin.impact_report.instance_follows": "Kullanıcılarının kaybedeceği takipçiler",
  "admin.impact_report.title": "Etki özeti",
  "alert.rate_limited.message": "Lütfen sonra tekrar deneyin {retry_time, time, medium}.",
  "alert.rate_limited.title": "Aşırı istek gönderildi",
  "alert.unexpected.message": "Beklenmedik bir hata oluştu.",
  "alert.unexpected.title": "Hay aksi!",
  "alt_text_badge.title": "Alternatif metin",
  "alt_text_modal.add_alt_text": "Alternatif metin ekle",
  "alt_text_modal.add_text_from_image": "Resimden metin ekle",
  "alt_text_modal.cancel": "İptal et",
  "alt_text_modal.change_thumbnail": "Küçük resmi değiştir",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Bunu işitme sorunu yaşayan kişiler için betimleyin…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Bunu görme bozukluğu yaşayan kişiler için betimleyin…",
  "alt_text_modal.done": "Tamamlandı",
  "announcement.announcement": "Duyuru",
  "annual_report.announcement.action_build": "Wrapstodon'umu Oluştur",
  "annual_report.announcement.action_dismiss": "Hayır teşekkürler",
  "annual_report.announcement.action_view": "Wrapstodon'umu Görüntüle",
  "annual_report.announcement.description": "Mastodon'daki geçen yıldaki etkileşimleriniz hakkında daha fazlasını öğrenin.",
  "annual_report.announcement.title": "{year} Wrapstodon'u yayında",
  "annual_report.nav_item.badge": "Yeni",
  "annual_report.shared_page.donate": "Bağış Yap",
  "annual_report.shared_page.footer": "Mastodon ekibi tarafından {heart} ile oluşturulmuştur",
  "annual_report.shared_page.footer_server_info": "{username}, Mastodon tarafından desteklenen birçok topluluktan biri olan {domain} kullanıyor.",
  "annual_report.summary.archetype.booster.desc_public": "{name} mükemmel bir hedefle diğer içerik üreticilerini desteklemek için paylaşımları yeniden yayınlamaya devam etti.",
  "annual_report.summary.archetype.booster.desc_self": "Mükemmel bir hedefle diğer içerik üreticilerini desteklemek için paylaşımları yeniden yayınlamaya devam ettin.",
  "annual_report.summary.archetype.booster.name": "Okçu",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "{name} orada, bir yerlerde, kendi sessiz tarzıyla Mastodon'un tadını çıkarıyor, biliyoruz.",
  "annual_report.summary.archetype.lurker.desc_self": "Orada, bir yerlerde, kendi sessiz tarzınla Mastodon'un tadını çıkarıyorsun, biliyoruz.",
  "annual_report.summary.archetype.lurker.name": "Stoacı",
  "annual_report.summary.archetype.oracle.desc_public": "{name} yanıtlardan daha çok yeni gönderi oluşturarak Mastodon'u taze ve geleceğe dönük tuttu.",
  "annual_report.summary.archetype.oracle.desc_self": "Yanıtlardan daha çok yeni gönderi oluşturarak Mastodon'u taze ve geleceğe dönük tuttun.",
  "annual_report.summary.archetype.oracle.name": "Kahin",
  "annual_report.summary.archetype.pollster.desc_public": "{name} diğer gönderi türlerinden çok anket oluşturarak Mastodon'da merak uyandırdı.",
  "annual_report.summary.archetype.pollster.desc_self": "Diğer gönderi türlerinden çok anket oluşturarak Mastodon'da merak uyandırdın.",
  "annual_report.summary.archetype.pollster.name": "Meraklı",
  "annual_report.summary.archetype.replier.desc_public": "{name} sık sık diğer kullanıcıların gönderilerine yanıt vererek Mastodon'a yeni tartışmalar kazandırdı.",
  "annual_report.summary.archetype.replier.desc_self": "Sık sık diğer kullanıcıların gönderilerine yanıt vererek Mastodon'a yeni tartışmalar kazandırdın.",
  "annual_report.summary.archetype.replier.name": "Kelebek",
  "annual_report.summary.archetype.reveal": "Arketipimi Göster",
  "annual_report.summary.archetype.reveal_description": "Mastodon'un bir parçası olduğun için teşekkürler! {year} yılında hangi arketipi temsil ettiğini öğrenme zamanı geldi.",
  "annual_report.summary.archetype.title_public": "{name} kullanıcısının arketipi",
  "annual_report.summary.archetype.title_self": "Arketipin",
  "annual_report.summary.close": "Kapat",
  "annual_report.summary.copy_link": "Bağlantıyı kopyala",
  "annual_report.summary.followers.new_followers": "{count, plural, one {1 yeni takipçi} other {# yeni takipçi}}",
  "annual_report.summary.highlighted_post.boost_count": "Bu gönderi {count, plural, one {1 kez} other {# kez}} yeniden paylaşıldı.",
  "annual_report.summary.highlighted_post.favourite_count": "Bu gönderi {count, plural, one {1 kez} other {# kez}} beğenildi.",
  "annual_report.summary.highlighted_post.reply_count": "Bu gönderi {count, plural, one {1 yanıt} other {# yanıt}} aldı.",
  "annual_report.summary.highlighted_post.title": "En popüler gönderi",
  "annual_report.summary.most_used_app.most_used_app": "en çok kullanılan uygulama",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "en çok kullanılan etiket",
  "annual_report.summary.most_used_hashtag.used_count": "Bu etiketi {count, plural, one {1 gönderi} other {# gönderi}}de kullandınız.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} bu etiketi {count, plural, one {1 gönderi} other {# gönderi}}de kullandı.",
  "annual_report.summary.new_posts.new_posts": "yeni gönderiler",
  "annual_report.summary.percentile.text": "<bottomLabel>{domain} kullanıcılarının</bottomLabel><percentage></percentage><topLabel>üst dilimindesiniz</topLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Bernie'ye söylemeyiz.",
  "annual_report.summary.share_elsewhere": "Başka yerde paylaş",
  "annual_report.summary.share_message": "{archetype} arketipindeyim!",
  "annual_report.summary.share_on_mastodon": "Mastodon'da Paylaş",
  "attachments_list.unprocessed": "(işlenmemiş)",
  "audio.hide": "Sesi gizle",
  "block_modal.no_collections": "İkiniz de birbirinizi koleksiyonlarınıza ekleyemezsiniz. Varsa, birbirinizin mevcut koleksiyonlarından otomatik olarak kaldırılacaksınız.",
  "block_modal.remote_users_caveat": "{domain} sunucusundan kararınıza saygı duymasını isteyeceğiz. Ancak, Uymaları garanti değildir çünkü bazı sunucular engellemeyi farklı şekilde yapıyorlar. Herkese açık gönderiler giriş yapmamış kullanıcılara görüntülenmeye devam edebilir.",
  "block_modal.show_less": "Daha az göster",
  "block_modal.show_more": "Daha fazla göster",
  "block_modal.they_cant_mention": "Birbirinizden bahsedemez, birbirinizi takip edemez veya birbirinizin gönderilerini alıntılayamazsınız.",
  "block_modal.they_cant_see_posts": "Sizin içeriklerinizi göremez, siz de onun içeriklerini göremezsiniz.",
  "block_modal.they_will_know": "Engellendiklerini görebiliyorlar.",
  "block_modal.title": "Kullanıcıyı engelle?",
  "block_modal.you_wont_see_mentions": "Bu kullanıcıdan bahseden diğer kullanıcıların gönderilerini göremeyeceksiniz.",
  "boost_modal.combo": "Bir daha ki sefere {combo} tuşuna basabilirsin",
  "boost_modal.reblog": "Gönderiyi yeniden paylaş?",
  "boost_modal.undo_reblog": "Gönderinin yeniden paylaşımını geri al?",
  "bundle_column_error.copy_stacktrace": "Hata raporunu kopyala",
  "bundle_column_error.error.body": "İstenen sayfa gösterilemiyor. Bu durum kodumuzdaki bir hatadan veya tarayıcı uyum sorunundan kaynaklanıyor olabilir.",
  "bundle_column_error.error.title": "Ah, hayır!",
  "bundle_column_error.network.body": "Sayfayı yüklemeye çalışırken bir hata oluştu. Bu durum internet bağlantınızdaki veya bu sunucudaki geçici bir sorundan kaynaklanıyor olabilir.",
  "bundle_column_error.network.title": "Ağ hatası",
  "bundle_column_error.retry": "Tekrar deneyin",
  "bundle_column_error.return": "Ana sayfaya geri dön",
  "bundle_column_error.routing.body": "İstenen sayfa bulunamadı. Adres çubuğundaki URL'nin doğru olduğundan emin misiniz?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Kapat",
  "bundle_modal_error.message": "Bu ekran yüklenirken bir şeyler ters gitti.",
  "bundle_modal_error.retry": "Tekrar deneyin",
  "callout.dismiss": "Yoksay",
  "carousel.current": "<sr>Slayt</sr> {current, number} / {max, number}",
  "carousel.slide": "Slayt {current, number} / {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} önerilen karakter",
  "character_counter.required": "{currentLength}/{maxLength} karakter",
  "closed_registrations.other_server_instructions": "Mastodon merkeziyetsiz olduğu için, başka bir sunucuda bir hesap oluşturabilir ve bu sunucuyla etkileşimde bulunmaya devam edebilirsiniz.",
  "closed_registrations_modal.description": "{domain} adresinde hesap oluşturmak şu an mümkün değil ancak unutmayın ki Mastodon kullanmak için özellikle {domain} adresinde hesap oluşturmanız gerekmez.",
  "closed_registrations_modal.find_another_server": "Başka sunucu bul",
  "closed_registrations_modal.preamble": "Mastodon merkeziyetsizdir, bu yüzden hesabınızı nerede oluşturursanız oluşturun, bu sunucudaki herhangi birini takip edebilecek veya onunla etkileşebileceksiniz. Hatta kendi sunucunuzu bile barındırabilirsiniz!",
  "closed_registrations_modal.title": "Mastodon'a kayıt olmak",
  "collection.share_modal.share_link_label": "Bağlantıyı paylaş",
  "collection.share_modal.share_via_post": "Mastodon'da paylaş",
  "collection.share_modal.share_via_system": "Paylaş…",
  "collection.share_modal.title": "Koleksiyonu paylaş",
  "collection.share_modal.title_new": "Yeni koleksiyonunuzu paylaşın!",
  "collection.share_template_other": "Bu harika koleksiyona göz atın: {link}",
  "collection.share_template_own": "Yeni koleksiyonuma göz atın: {link}",
  "collections.account_count": "{count, plural, one {# hesap} other {# hesap}}",
  "collections.accounts.empty_description": "{count} hesap ekleyebilirsiniz",
  "collections.accounts.empty_editor_title": "Koleksiyonda henüz kimse yok",
  "collections.accounts.empty_title": "Bu koleksiyon boş",
  "collections.block_collection_owner": "Hesabı engelle",
  "collections.by_account": "Hazırlayan: {account_handle}",
  "collections.collection_description": "Açıklama",
  "collections.collection_language": "Dil",
  "collections.collection_language_none": "Hiçbiri",
  "collections.collection_name": "Ad",
  "collections.collection_topic": "Konu",
  "collections.confirm_account_removal": "Bu hesabı bu koleksiyondan çıkarmak istediğinizden emin misiniz?",
  "collections.content_warning": "İçerik uyarısı",
  "collections.continue": "Devam et",
  "collections.copy_link": "Bağlantıyı kopyala",
  "collections.copy_link_confirmation": "Koleksiyon bağlantısı panoya kopyalandı",
  "collections.create.accounts_title": "Bu koleksiyonda kimleri öne çıkaracaksınız?",
  "collections.create.basic_details_title": "Temel bilgiler",
  "collections.create.steps": "Adım {step}/{total}",
  "collections.create_collection": "Koleksiyon oluştur",
  "collections.delete_collection": "Koleksiyonu sil",
  "collections.description_length_hint": "100 karakterle sınırlı",
  "collections.detail.author_added_you_on_date": "{author}, sizi {date} tarihinde ekledi",
  "collections.detail.loading": "Koleksiyon yükleniyor…",
  "collections.detail.revoke_inclusion": "Beni çıkar",
  "collections.detail.sensitive_content": "Hassas içerik",
  "collections.detail.sensitive_note": "Bu koleksiyon bazı kullanıcılar için hassas olabilecek hesap ve içerik içerebilir.",
  "collections.detail.share": "Bu koleksiyonu paylaş",
  "collections.detail.you_are_in_this_collection": "Bu koleksiyonda öne çıkanlardasınız",
  "collections.edit_details": "Ayrıntıları düzenle",
  "collections.error_loading_collections": "Bu koleksiyonları yüklemeye çalışırken bir hata oluştu.",
  "collections.hidden_accounts_description": "Bu {count, plural, one {kullanıcıyı} other {kullanıcıları}} engellediniz veya sessize aldınız",
  "collections.hidden_accounts_link": "{count, plural, one {# gizli hesap} other {# gizli hesap}}",
  "collections.hints.accounts_counter": "{count}/{max} hesap",
  "collections.last_updated_at": "Son güncelleme: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Koleksiyon} other {# Koleksiyon}}",
  "collections.list.created_by_author": "{name} tarafından oluşturuldu",
  "collections.list.created_by_you": "Sizin tarafınızdan oluşturuldu",
  "collections.list.featuring_you": "Sizi içeriyor",
  "collections.manage_accounts": "Hesapları yönet",
  "collections.mark_as_sensitive": "Hassas olarak işaretle",
  "collections.mark_as_sensitive_hint": "Koleksiyonun açıklamasını ve hesaplarını içerik uyarısının arkasında gizler. Koleksiyon adı hala görünür olacaktır.",
  "collections.maximum_collection_count_description": "Sunucusunuz en fazla {count} koleksiyon oluşturmanıza izin veriyor.",
  "collections.maximum_collection_count_reached": "Maksimum koleksiyon sayısına ulaştınız",
  "collections.name_length_hint": "40 karakterle sınırlı",
  "collections.new_collection": "Yeni koleksiyon",
  "collections.pending_accounts.message": "Kullanıcıdan veya sunucusundan yanıt beklediğimizde hesaplar \"beklemede\" olarak görünebilir. Beklemede olan hesapları yalnızca siz görebilirsiniz.",
  "collections.pending_accounts.title": "Neden beklemede olan hesapları görüyorum?",
  "collections.remove_account": "Kaldır",
  "collections.report_collection": "Bu koleksiyonu bildir",
  "collections.revoke_collection_inclusion": "Beni bu koleksiyondan çıkar",
  "collections.revoke_inclusion.confirmation": "\"{collection}\" koleksiyonundan çıkarıldınız",
  "collections.revoke_inclusion.error": "Bir hata oluştu, lütfen daha sonra tekrar deneyin.",
  "collections.search_accounts_label": "Eklemek için hesap arayın",
  "collections.search_accounts_max_reached": "Maksimum hesabı eklediniz",
  "collections.sensitive": "Hassas",
  "collections.share_short": "Paylaş",
  "collections.suggestions.can_not_add": "Eklenemez",
  "collections.suggestions.can_not_add_desc": "Bu hesaplar, keşfedilmek istemiyor veya koleksiyonları desteklemeyen bir sunucuda yer alıyor olabilirler.",
  "collections.suggestions.must_follow": "İlk önce takip etmelisiniz",
  "collections.suggestions.must_follow_desc": "Bu hesaplar tüm takip isteklerini inceler. Takipçileri bunları koleksiyonlarına ekleyebilir.",
  "collections.topic_hint": "Bu koleksiyonun ana konusunu başkalarının anlamasına yardımcı olacak bir etiket ekleyin.",
  "collections.topic_special_chars_hint": "Kaydederken özel karakterler silinecektir",
  "collections.unlisted_collections_description": "Bunlar profilinizde başkalarına görünmez. Bağlantıya sahip olan herkes bunları görebilir.",
  "collections.unlisted_collections_with_count": "Listelenmeyen koleksiyonlar ({count})",
  "collections.view_collection": "Koleksiyonu görüntüle",
  "collections.visibility_public": "Herkese açık",
  "collections.visibility_public_hint": "Arama sonuçlarında ve önerilerin görüntülendiği diğer alanlarda keşfedilebilir.",
  "collections.visibility_title": "Görünürlük",
  "collections.visibility_unlisted": "Listelenmemiş",
  "collections.visibility_unlisted_hint": "Bağlantısı olan herkes tarafından görülebilir. Arama sonuçlarında ve önerilerde gizlenir.",
  "column.about": "Hakkında",
  "column.blocks": "Engellenen kullanıcılar",
  "column.bookmarks": "Yer İşaretleri",
  "column.community": "Yerel ağ akışı",
  "column.create_list": "Liste oluştur",
  "column.direct": "Özel bahsetmeler",
  "column.directory": "Profillere göz at",
  "column.domain_blocks": "Engellenen alan adları",
  "column.edit_list": "Listeyi düzenle",
  "column.favourites": "Gözdelerin",
  "column.firehose": "Anlık Akışlar",
  "column.firehose_local": "Bu sunucunun canlı akışı",
  "column.firehose_singular": "Canlı akış",
  "column.follow_requests": "Takip istekleri",
  "column.home": "Ana Sayfa",
  "column.list_members": "Liste üyelerini yönet",
  "column.lists": "Listeler",
  "column.mutes": "Sessize alınmış kullanıcılar",
  "column.notifications": "Bildirimler",
  "column.other_collections": "{name} koleksiyonları",
  "column.pins": "Sabitlenmiş gönderiler",
  "column.public": "Federe ağ akışı",
  "column.your_collections": "Koleksiyonlarınız",
  "column_back_button.label": "Geri",
  "column_header.hide_settings": "Ayarları gizle",
  "column_header.moveLeft_settings": "Sütunu sola taşı",
  "column_header.moveRight_settings": "Sütunu sağa taşı",
  "column_header.pin": "Sabitle",
  "column_header.show_settings": "Ayarları göster",
  "column_header.unpin": "Sabitlemeyi kaldır",
  "column_search.cancel": "İptal",
  "combobox.close_results": "Sonuçları kapat",
  "combobox.loading": "Yükleniyor",
  "combobox.no_results_found": "Bu arama için hiçbir sonuç bulunamadı",
  "combobox.open_results": "Sonuçları aç",
  "combobox.results_available": "{count, plural, one {# öneri} other {# öneri}} var. Önerileri görmek için yukarı ve aşağı ok tuşlarını kullanın. Seçmek için Enter tuşuna basın.",
  "community.column_settings.local_only": "Sadece yerel",
  "community.column_settings.media_only": "Sadece medya",
  "community.column_settings.remote_only": "Sadece uzak",
  "compose.error.blank_post": "Gönderiler boş bırakılamaz.",
  "compose.language.change": "Dili değiştir",
  "compose.language.search": "Dilleri ara...",
  "compose.published.body": "Gönderi yayınlandı.",
  "compose.published.open": "Aç",
  "compose.saved.body": "Gönderi kaydedildi.",
  "compose_form.direct_message_warning_learn_more": "Daha fazla bilgi edinin",
  "compose_form.encryption_warning": "Mastodon gönderileri uçtan uca şifreli değildir. Hassas olabilecek herhangi bir bilgiyi Mastodon'da paylaşmayınız.",
  "compose_form.hashtag_warning": "Bu gönderi herkese açık olmadığı için hiç bir etikette yer almayacak. Sadece herkese açık gönderiler etiketlerde bulunabilir.",
  "compose_form.lock_disclaimer": "Hesabın {locked} değil. Yalnızca takipçilere özel gönderilerini görüntülemek için herkes seni takip edebilir.",
  "compose_form.lock_disclaimer.lock": "kilitli",
  "compose_form.placeholder": "Aklında ne var?",
  "compose_form.poll.duration": "Anket süresi",
  "compose_form.poll.multiple": "Çoktan seçmeli",
  "compose_form.poll.option_placeholder": "Seçenek {number}",
  "compose_form.poll.single": "Tekli seçim",
  "compose_form.poll.switch_to_multiple": "Birden çok seçeneğe izin vermek için anketi değiştir",
  "compose_form.poll.switch_to_single": "Tek bir seçeneğe izin vermek için anketi değiştir",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Gönder",
  "compose_form.reply": "Yanıtla",
  "compose_form.save_changes": "Güncelle",
  "compose_form.spoiler.marked": "İçerik uyarısını kaldır",
  "compose_form.spoiler.unmarked": "İçerik uyarısı ekle",
  "compose_form.spoiler_placeholder": "İçerik uyarısı (isteğe bağlı)",
  "confirmation_modal.cancel": "İptal",
  "confirmations.block.confirm": "Engelle",
  "confirmations.delete.confirm": "Sil",
  "confirmations.delete.message": "Bu tootu silmek istediğinden emin misin?",
  "confirmations.delete.title": "Gönderiyi sil?",
  "confirmations.delete_collection.confirm": "Sil",
  "confirmations.delete_collection.message": "Bu işlem geri alınamaz.",
  "confirmations.delete_collection.title": "\"{name}\" silinsin mi?",
  "confirmations.delete_list.confirm": "Sil",
  "confirmations.delete_list.message": "Bu listeyi kalıcı olarak silmek istediğinden emin misin?",
  "confirmations.delete_list.title": "Listeyi sil?",
  "confirmations.discard_draft.confirm": "Sil ve devam et",
  "confirmations.discard_draft.edit.cancel": "Düzenlemeye devam et",
  "confirmations.discard_draft.edit.message": "Devam ederseniz düzenlemekte olduğunuz gönderide yaptığınız tüm değişiklikler silinecektir.",
  "confirmations.discard_draft.edit.title": "Gönderinize yaptığınız değişiklikler silinsin mi?",
  "confirmations.discard_draft.post.cancel": "Taslağa devam et",
  "confirmations.discard_draft.post.message": "Devam ederseniz, şu anda oluşturmakta olduğunuz gönderi silinecektir.",
  "confirmations.discard_draft.post.title": "Taslak gönderiniz silinsin mi?",
  "confirmations.discard_edit_media.confirm": "Vazgeç",
  "confirmations.discard_edit_media.message": "Medya açıklaması veya ön izlemede kaydedilmemiş değişiklikleriniz var, yine de vazgeçmek istiyor musunuz?",
  "confirmations.follow_to_list.confirm": "Takip et ve yapılacaklar listesine ekle",
  "confirmations.follow_to_list.message": "Bir listeye eklemek için {name} kişisini takip etmeniz gerekiyor.",
  "confirmations.follow_to_list.title": "Kullanıcıyı takip et?",
  "confirmations.hide_featured_tab.confirm": "Sekmeyi Gizle",
  "confirmations.hide_featured_tab.intro": "Bunu istediğiniz zaman <i>Profil düzenle > Profil sekmesi ayarları</i> bölümünden değiştirebilirsiniz.",
  "confirmations.hide_featured_tab.message": "Bu, {serverName} ve Mastodon'un en son sürümünü çalıştıran diğer sunuculardaki kullanıcılar için sekmeyi gizleyecektir. Diğer sunucularda görüntü farklılık gösterebilir.",
  "confirmations.hide_featured_tab.title": "\"Öne Çıkanlar\" sekmesi gizlensin mi?",
  "confirmations.logout.confirm": "Oturumu kapat",
  "confirmations.logout.message": "Oturumu kapatmak istediğinden emin misin?",
  "confirmations.logout.title": "Oturumu kapat?",
  "confirmations.missing_alt_text.confirm": "Alternatif metin ekle",
  "confirmations.missing_alt_text.message": "Gönderiniz alternatif metni olmayan medya içeriyor. Tanımlamalar eklemek, içeriğinizi insanlar açısından daha erişilebilir kılar.",
  "confirmations.missing_alt_text.secondary": "Yine de gönder",
  "confirmations.missing_alt_text.title": "Alternatif metin ekle?",
  "confirmations.mute.confirm": "Sessize al",
  "confirmations.private_quote_notify.cancel": "Düzenlemeye dön",
  "confirmations.private_quote_notify.confirm": "Gönderiyi yayınla",
  "confirmations.private_quote_notify.do_not_show_again": "Bu iletiyi bana tekrar gösterme",
  "confirmations.private_quote_notify.message": "Alıntı yaptığınız kişi ve diğer bahsedilen kişiler, sizi takip etmiyor olsalar bile bildirim alacak ve gönderinizi görüntüleyebileceklerdir.",
  "confirmations.private_quote_notify.title": "Takipçiler ve bahsedilen kullanıcılarla paylaş?",
  "confirmations.quiet_post_quote_info.dismiss": "Bana bir daha hatırlatma",
  "confirmations.quiet_post_quote_info.got_it": "Anladım",
  "confirmations.quiet_post_quote_info.message": "Sessiz bir genel gönderiyi alıntıladığınızda, gönderiniz öne çıkan zaman çizelgelerinden gizlenir.",
  "confirmations.quiet_post_quote_info.title": "Herkese açık sessiz gönderileri alıntılamak",
  "confirmations.redraft.confirm": "Sil Düzenle ve yeniden paylaş",
  "confirmations.redraft.message": "Bu gönderiyi silip taslak haline getirmek istediğinize emin misiniz? Mevcut favoriler ve boostlar silinecek ve gönderiye verilen yanıtlar başıboş kalacak.",
  "confirmations.redraft.title": "Gönderiyi sil veya taslağa dönüştür?",
  "confirmations.remove_from_followers.confirm": "Takipçi kaldır",
  "confirmations.remove_from_followers.message": "{name} sizi takip etmeyi bırakacaktır. Devam etmek istediğinize emin misiniz?",
  "confirmations.remove_from_followers.title": "Takipçiyi kaldır?",
  "confirmations.revoke_collection_inclusion.confirm": "Beni çıkar",
  "confirmations.revoke_collection_inclusion.message": "Bu eylem kalıcıdır ve koleksiyonu derleyen kişi daha sonra sizi koleksiyona tekrar ekleyemeyecektir.",
  "confirmations.revoke_collection_inclusion.title": "Kendini bu koleksiyondan çıkar?",
  "confirmations.revoke_quote.confirm": "Gönderiyi kaldır",
  "confirmations.revoke_quote.message": "Bu işlem geri alınamaz.",
  "confirmations.revoke_quote.title": "Gönderiyi silmek ister misiniz?",
  "confirmations.unblock.confirm": "Engeli kaldır",
  "confirmations.unblock.title": "{name} için engel kaldırılsın mı?",
  "confirmations.unfollow.confirm": "Takibi bırak",
  "confirmations.unfollow.title": "{name} kullanıcısının takibi bırakılsın mı?",
  "confirmations.withdraw_request.confirm": "İsteği geri çek",
  "confirmations.withdraw_request.title": "{name} takip isteği geri çekilsin mi?",
  "content_warning.hide": "Gönderiyi gizle",
  "content_warning.show": "Yine de göster",
  "content_warning.show_more": "Daha fazla göster",
  "content_warning.show_short": "Göster",
  "conversation.delete": "Sohbeti sil",
  "conversation.mark_as_read": "Okundu olarak işaretle",
  "conversation.open": "Sohbeti görüntüle",
  "conversation.with": "{names} ile",
  "copy_icon_button.copied": "Panoya kopyalandı",
  "copy_icon_button.copy_this_text": "Bağlantıyı panoya kopyala",
  "copypaste.copied": "Kopyalandı",
  "copypaste.copy_to_clipboard": "Panoya kopyala",
  "directory.federated": "Bilinen fediverse'lerden",
  "directory.local": "Yalnızca {domain} adresinden",
  "directory.new_arrivals": "Yeni gelenler",
  "directory.recently_active": "Son zamanlarda aktif",
  "disabled_account_banner.account_settings": "Hesap ayarları",
  "disabled_account_banner.text": "{disabledAccount} hesabınız şu an devre dışı.",
  "dismissable_banner.community_timeline": "Bunlar, {domain} sunucusunda hesabı olanların yakın zamandaki herkese açık gönderileridir.",
  "dismissable_banner.dismiss": "Yoksay",
  "dismissable_banner.public_timeline": "Bunlar, {domain} üzerindeki insanların takip ettiği fediverse üzerindeki kişilerin en son ve herkese açık gönderileridir.",
  "domain_block_modal.block": "Sunucuyu engelle",
  "domain_block_modal.block_account_instead": "Bunun yerine {name} hesabını engelle",
  "domain_block_modal.they_can_interact_with_old_posts": "Bu sunucudan kişiler eski gönderilerinizle etkileşebilirler.",
  "domain_block_modal.they_cant_follow": "Bu sunucudan hiç kimse sizi takip edemez.",
  "domain_block_modal.they_wont_know": "Engellendiklerini bilmeyecekler.",
  "domain_block_modal.title": "Alan adını engelle?",
  "domain_block_modal.you_will_lose_num_followers": "{followersCount, plural, one {{followersCountDisplay} takipçi} other {{followersCountDisplay} takipçi}} ve {followingCount, plural, one {{followingCountDisplay} takip ettiğiniz kişi} other {{followingCountDisplay} takip ettiğiniz kişi}} kaybedeceksiniz.",
  "domain_block_modal.you_will_lose_relationships": "Bu sunucudaki tüm takip edenleri ve takip ettiklerinizi kaybedeceksiniz.",
  "domain_block_modal.you_wont_see_posts": "Bu sunucudaki kullanıcılardan gelen gönderileri veya bildirimleri göremezsiniz.",
  "domain_pill.activitypub_lets_connect": "Sadece Mastodon üzerindeki değil, diğer sosyal uygulamalardaki kişilerle de bağlantı kurmanıza ve etkileşmenize olanak sağlar.",
  "domain_pill.activitypub_like_language": "ActivityPub, Mastodon'un diğer sosyal ağlarla konuşmak için kullandığı dil gibidir.",
  "domain_pill.server": "Sunucu",
  "domain_pill.their_handle": "Kullanıcı kimliği:",
  "domain_pill.their_server": "Dijital evleri, tüm gönderilerinin yaşadığı yerdir.",
  "domain_pill.their_username": "Sunucularındaki tekil tanımlayıcıları. Farklı sunucularda aynı kullanıcı adına sahip kullanıcıları bulmak mümkündür.",
  "domain_pill.username": "Kullanıcı adı",
  "domain_pill.whats_in_a_handle": "Kullanıcı kimliği nedir?",
  "domain_pill.who_they_are": "Kullanıcı kimlikleri bir kişinin kim olduğunu ve nerede olduğunu söylediği için, <button>ActivityPub destekli platformların</button> sosyal ağındaki insanlarla etkileşime geçebilirsiniz.",
  "domain_pill.who_you_are": "Kullanıcı kimliğiniz kim olduğunuzu ve nerede olduğunuzu söylediği için, <button>ActivityPub destekli platformların</button> sosyal ağındaki insanlar sizinle etkileşime geçebilir.",
  "domain_pill.your_handle": "Kullanıcı kimliğiniz:",
  "domain_pill.your_server": "Dijital anasayfanız, tüm gönderilerinizin yaşadığı yerdir. Bunu beğenmediniz mi? İstediğiniz zaman sunucularınızı değiştirin ve takipçilerinizi de getirin.",
  "domain_pill.your_username": "Bu sunucudaki tekil tanımlayıcınız. Farklı sunucularda aynı kullanıcı adına sahip kullanıcıları bulmak mümkündür.",
  "dropdown.empty": "Bir seçenek seçin",
  "email_subscriptions.email": "E-posta",
  "email_subscriptions.form.action": "Abone ol",
  "email_subscriptions.form.bottom": "Gönderiler Mastodon hesabı oluşturmadan e-posta kutunuza gelsin. İstediğiniz zaman aboneliğinizi iptal edebilirsiniz. Daha fazla bilgi için <a>Gizlilik Politikası</a>'na bakın.",
  "email_subscriptions.form.title": "{name} kişisinin e-posta güncellemelerine kaydolun",
  "email_subscriptions.submitted.lead": "E-posta güncellemelerine kaydolma işlemini tamamlamak için gelen kutunuzu kontrol edin.",
  "email_subscriptions.submitted.title": "Bir adım daha",
  "email_subscriptions.validation.email.blocked": "Engellenmiş e-posta sağlayıcı",
  "email_subscriptions.validation.email.invalid": "Geçersiz eposta adresi",
  "embed.instructions": "Aşağıdaki kodu kopyalayarak bu durumu sitenize gömün.",
  "embed.preview": "İşte böyle görünecek:",
  "emoji_button.activity": "Aktivite",
  "emoji_button.clear": "Temizle",
  "emoji_button.custom": "Özel",
  "emoji_button.flags": "Bayraklar",
  "emoji_button.food": "Yiyecek ve İçecek",
  "emoji_button.label": "İfade ekle",
  "emoji_button.nature": "Doğa",
  "emoji_button.not_found": "Eşleşen emoji yok",
  "emoji_button.objects": "Nesneler",
  "emoji_button.people": "Kullanıcılar",
  "emoji_button.recent": "Sık kullanılan",
  "emoji_button.search": "Ara...",
  "emoji_button.search_results": "Arama sonuçları",
  "emoji_button.symbols": "Semboller",
  "emoji_button.travel": "Seyahat ve Yerler",
  "empty_column.account_featured.other": "{acct} henüz hiçbir şeyi öne çıkarmadı.",
  "empty_column.account_featured_self.no_collections_button": "Bir koleksiyon oluştur",
  "empty_column.account_featured_self.no_collections_hide_tab": "Onun yerine bu sekmeyi gizle",
  "empty_column.account_featured_self.pre_collections": "Koleksiyonlar için beklemede kalın",
  "empty_column.account_featured_self.pre_collections_desc": "“Koleksiyonlar” (Mastodon 4.6 sürümünde kullanıma sunulacak) özelliği başkalarına önermek üzere kendi seçtiğiniz hesap listelerini oluşturmanıza olanak tanır.",
  "empty_column.account_featured_self.showcase_accounts": "Sevdiğiniz hesapları öne çıkarın",
  "empty_column.account_featured_self.showcase_accounts_desc": "Koleksiyonlar başkalarının Fediverse'i daha iyi keşfetmesine yardımcı olmak amacıyla derlenmiş hesap listeleridir.",
  "empty_column.account_featured_unknown.other": "Bu hesap henüz hiçbir şeyi öne çıkarmadı.",
  "empty_column.account_hides_collections": "Bu kullanıcı bu bilgiyi sağlamayı tercih etmemiştir",
  "empty_column.account_suspended": "Hesap askıya alındı",
  "empty_column.account_timeline": "Burada hiç gönderi yok!",
  "empty_column.account_unavailable": "Profil kullanılamıyor",
  "empty_column.blocks": "Henüz herhangi bir kullanıcıyı engellemedin.",
  "empty_column.bookmarked_statuses": "Henüz yer imine eklediğin toot yok. Bir tanesi yer imine eklendiğinde burada görünür.",
  "empty_column.collections.featured_in": "Henüz herhangi bir koleksiyona eklenmediniz.",
  "empty_column.community": "Yerel zaman çizelgesi boş. Daha fazla eğlence için herkese açık bir gönderi paylaşın!",
  "empty_column.direct": "Henüz doğrudan değinmeniz yok. Bir tane gönderdiğinizde veya aldığınızda burada listelenecek.",
  "empty_column.disabled_feed": "Bu akış sunucu yöneticileri tarafından devre dışı bırakılmıştır.",
  "empty_column.domain_blocks": "Henüz engellenmiş bir alan adı yok.",
  "empty_column.explore_statuses": "Şu an öne çıkan birşey yok. Daha sonra tekrar bakın!",
  "empty_column.favourited_statuses": "Henüz bir gönderiyi favorilerinize eklememişsiniz. Bir gönderiyi favorilerinize eklediğinizde burada görünecek.",
  "empty_column.favourites": "Bu yazıyı henüz hiç kimse beğenmedi. Biri geldiğinde, buraya gelecekler.",
  "empty_column.follow_requests": "Hiç takip isteğiniz yok. Bir tane aldığınızda burada görünecek.",
  "empty_column.followed_tags": "Henüz hiç bir etiket takip etmiyorsunuz. Takip ettiğiniz etiketler burada görüntülenecek.",
  "empty_column.hashtag": "Henüz bu etikete sahip hiçbir gönderi yok.",
  "empty_column.home": "Ana zaman tünelin boş! Akışını doldurmak için daha fazla kişiyi takip ediniz.",
  "empty_column.list": "Henüz bu listede bir şey yok. Bu listenin üyeleri bir şey paylaşığında burada gözükecek.",
  "empty_column.mutes": "Henüz bir kullanıcıyı sessize almadınız.",
  "empty_column.notification_requests": "Hepsi tamam! Burada yeni bir şey yok. Yeni bildirim aldığınızda, ayarlarınıza göre burada görüntülenecekler.",
  "empty_column.notifications": "Henüz bildiriminiz yok. Sohbete başlamak için başkalarıyla etkileşim kurun.",
  "empty_column.public": "Burada hiçbir şey yok! Herkese açık bir şeyler yazın veya burayı doldurmak için diğer sunuculardaki kullanıcıları takip edin",
  "empty_state.no_results": "Sonuç yok",
  "error.no_hashtag_feed_access": "Bu etiketi görüntülemek ve takip etmek için katılın veya giriş yapın.",
  "error.unexpected_crash.explanation": "Bizim kodumuzdaki bir hatadan ya da tarayıcı uyumluluk sorunundan dolayı, bu sayfa düzgün görüntülenemedi.",
  "error.unexpected_crash.explanation_addons": "Bu sayfa doğru görüntülenemedi. Bu hata büyük olasılıkla bir tarayıcı eklentisinden veya otomatik çeviri araçlarından kaynaklanır.",
  "error.unexpected_crash.next_steps": "Sayfayı yenilemeyi deneyin. Eğer bu yardımcı olmazsa, Mastodon'u farklı bir tarayıcı ya da yerel uygulama üzerinden kullanabilirsiniz.",
  "error.unexpected_crash.next_steps_addons": "Bunları devre dışı bırakmayı ve sayfayı yenilemeyi deneyin. Bu yardımcı olmazsa, Mastodon'u başka bir tarayıcı veya yerel uygulama aracılığıyla kullanabilirsiniz.",
  "errors.unexpected_crash.copy_stacktrace": "Yığın izlemeyi panoya kopyala",
  "errors.unexpected_crash.report_issue": "Sorun bildir",
  "explore.suggested_follows": "Kullanıcılar",
  "explore.title": "Öne çıkanlar",
  "explore.trending_links": "Haberler",
  "explore.trending_statuses": "Gönderiler",
  "explore.trending_tags": "Etiketler",
  "featured_carousel.current": "<sr>Gönderi</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {{counter} Sabitlenmiş Gönderi} other {{counter} Sabitlenmiş Gönderi}}",
  "featured_carousel.slide": "Gönderi {current, number} / {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Son zamanlarda {items} hakkında gönderileriniz var. Bunlar öne çıkan etiketler olarak eklensin mi?",
  "featured_tags.suggestions.add": "Ekle",
  "featured_tags.suggestions.added": "Öne çıkan etiketlerinizi istediğiniz zaman <link>Profil Düzenle > Öne çıkan etiketler</link> bölümünden yönetebilirsiniz.",
  "featured_tags.suggestions.dismiss": "Hayır teşekkürler",
  "filter_modal.added.context_mismatch_explanation": "Bu süzgeç kategorisi, bu gönderide eriştiğin bağlama uymuyor. Eğer gönderinin bu bağlamda da filtrelenmesini istiyorsanız, süzgeci düzenlemeniz gerekiyor.",
  "filter_modal.added.context_mismatch_title": "Bağlam uyumsuzluğu!",
  "filter_modal.added.expired_explanation": "Bu süzgeç kategorisinin süresi dolmuş, süzgeci uygulamak için bitiş tarihini değiştirmeniz gerekiyor.",
  "filter_modal.added.expired_title": "Süresi dolmuş süzgeç!",
  "filter_modal.added.review_and_configure": "Bu filtre kategorisini gözden geçirmek ve daha ayrıntılı bir şekilde yapılandırmak için {settings_link} adresine gidin.",
  "filter_modal.added.review_and_configure_title": "Süzgeç ayarları",
  "filter_modal.added.settings_link": "ayarlar sayfası",
  "filter_modal.added.short_explanation": "Bu gönderi şu süzgeç kategorisine eklendi: {title}.",
  "filter_modal.added.title": "Süzgeç eklendi!",
  "filter_modal.select_filter.context_mismatch": "bu bağlama uymuyor",
  "filter_modal.select_filter.expired": "süresi dolmuş",
  "filter_modal.select_filter.prompt_new": "Yeni kategori: {name}",
  "filter_modal.select_filter.search": "Ara veya oluştur",
  "filter_modal.select_filter.subtitle": "Mevcut bir kategoriyi kullan veya yeni bir tane oluştur",
  "filter_modal.select_filter.title": "Bu gönderiyi süzgeçle",
  "filter_modal.title.status": "Bir gönderi süzgeçle",
  "filter_warning.matches_filter": "“<span>{title}</span>” filtresiyle eşleşiyor",
  "filtered_notifications_banner.pending_requests": "Bildiğiniz {count, plural, =0 {hiç kimseden} one {bir kişiden} other {# kişiden}}",
  "filtered_notifications_banner.title": "Filtrelenmiş bildirimler",
  "firehose.all": "Tümü",
  "firehose.local": "Bu sunucu",
  "firehose.remote": "Diğer sunucular",
  "follow_request.authorize": "İzin Ver",
  "follow_request.reject": "Reddet",
  "follow_requests.unlocked_explanation": "Hesabınız kilitli olmasa da, {domain} personeli bu hesaplardan gelen takip isteklerini gözden geçirmek isteyebileceğinizi düşündü.",
  "follow_suggestions.curated_suggestion": "Çalışanların seçtikleri",
  "follow_suggestions.dismiss": "Tekrar gösterme",
  "follow_suggestions.featured_longer": "{domain} takımı tarafından elle seçildi",
  "follow_suggestions.friends_of_friends_longer": "Takip ettiğiniz kişiler arasında popüler",
  "follow_suggestions.hints.featured": "Bu profil {domain} ekibi tarafından elle seçilmiştir.",
  "follow_suggestions.hints.friends_of_friends": "Bu profil takip ettiğiniz insanlar arasında popülerdir.",
  "follow_suggestions.hints.most_followed": "Bu, {domain} sunucusunda en fazla izlenen profildir.",
  "follow_suggestions.hints.most_interactions": "Bu, {domain} sunucusunda son zamanlarda oldukça fazla dikkat çeken bir profildir.",
  "follow_suggestions.hints.similar_to_recently_followed": "Bu profil, son zamanlarda takip ettiğiniz profillere benziyor.",
  "follow_suggestions.personalized_suggestion": "Kişiselleşmiş öneriler",
  "follow_suggestions.popular_suggestion": "Popüler öneriler",
  "follow_suggestions.popular_suggestion_longer": "{domain} üzerinde popüler",
  "follow_suggestions.similar_to_recently_followed_longer": "Yakın zamanda takip ettiğiniz hesaplara benziyor",
  "follow_suggestions.view_all": "Tümünü gör",
  "follow_suggestions.who_to_follow": "Takip edebileceklerin",
  "followed_tags": "Takip edilen etiketler",
  "followers.hide_other_followers": "Bu kullanıcı diğer takipçilerini görünür kılmamayı seçmiştir",
  "followers.title": "{name} takip ediliyor",
  "following.hide_other_following": "Bu kullanıcı takip ettiği diğer kişileri görünür kılmamayı seçmiştir",
  "following.title": "{name} takip ediyor",
  "footer.about": "Hakkında",
  "footer.about_mastodon": "Mastodon Hakkında",
  "footer.about_server": "{domain} Hakkında",
  "footer.about_this_server": "Hakkında",
  "footer.directory": "Profil dizini",
  "footer.get_app": "Uygulamayı indir",
  "footer.keyboard_shortcuts": "Klavye kısayolları",
  "footer.privacy_policy": "Gizlilik politikası",
  "footer.source_code": "Kaynak kodu görüntüle",
  "footer.status": "Durum",
  "footer.terms_of_service": "Hizmet şartları",
  "form_error.blank": "Alan boş bırakılamaz.",
  "form_field.optional": "(isteğe bağlı)",
  "generic.saved": "Kaydet",
  "getting_started.heading": "Başlarken",
  "hashtag.admin_moderation": "#{name} için denetim arayüzünü açın",
  "hashtag.browse": "#{hashtag} gönderilerine gözat",
  "hashtag.browse_from_account": "@{name} kişisinin #{hashtag} gönderilerine gözat",
  "hashtag.column_header.tag_mode.all": "ve {additional}",
  "hashtag.column_header.tag_mode.any": "ya da {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} olmadan",
  "hashtag.column_settings.select.no_options_message": "Öneri bulunamadı",
  "hashtag.column_settings.select.placeholder": "Etiketler girin…",
  "hashtag.column_settings.tag_mode.all": "Bunların hepsi",
  "hashtag.column_settings.tag_mode.any": "Herhangi biri",
  "hashtag.column_settings.tag_mode.none": "Bunların hiçbiri",
  "hashtag.column_settings.tag_toggle": "Bu sütundaki ek etiketleri içer",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} katılımcı} other {{counter} katılımcı}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} gönderi} other {{counter} gönderi}}",
  "hashtag.counter_by_uses_today": "bugün {count, plural, one {{counter} gönderi} other {{counter} gönderi}}",
  "hashtag.feature": "Profilimde öne çıkar",
  "hashtag.follow": "Etiketi takip et",
  "hashtag.mute": "#{hashtag} gönderilerini sessize al",
  "hashtag.unfeature": "Profilimde öne çıkarma",
  "hashtag.unfollow": "Etiketi takibi bırak",
  "hashtags.and_other": "…ve {count, plural, one {}other {# fazlası}}",
  "hints.profiles.followers_may_be_missing": "Bu profilin takipçileri eksik olabilir.",
  "hints.profiles.follows_may_be_missing": "Bu profilin takip edilenleri eksik olabilir.",
  "hints.profiles.posts_may_be_missing": "Bu profilin bazı gönderileri eksik olabilir.",
  "hints.profiles.see_more_followers": "{domain} adresinde daha fazla takipçi gör",
  "hints.profiles.see_more_follows": "{domain} adresinde daha fazla takip edilen gör",
  "hints.profiles.see_more_posts": "{domain} adresinde daha fazla gönderi gör",
  "home.column_settings.show_quotes": "Alıntıları göster",
  "home.column_settings.show_reblogs": "Yeniden paylaşımları göster",
  "home.column_settings.show_replies": "Yanıtları göster",
  "home.hide_announcements": "Duyuruları gizle",
  "home.pending_critical_update.body": "Lütfen Mastodon sunucunuzu en kısa sürede güncelleyin!",
  "home.pending_critical_update.link": "Güncellemelerini görün",
  "home.pending_critical_update.title": "Kritik güvenlik güncellemesi mevcut!",
  "home.show_announcements": "Duyuruları göster",
  "ignore_notifications_modal.disclaimer": "Mastodon bildirimlerini yok saydığınız kullanıcıları bilgilendiremez. Bildirimleri yok saymak iletilerin gönderilmesini durdurmayacaktır.",
  "ignore_notifications_modal.filter_instead": "Onun yerine filtrele",
  "ignore_notifications_modal.filter_to_act_users": "Kullanıcıları kabul etmeye, red etmeye veya bildirmeye devam edebileceksiniz",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtreleme olası kafa karışıklığını önlemeye yardımcı olur",
  "ignore_notifications_modal.filter_to_review_separately": "Filtrelenmiş bildirimleri ayrıca inceleyebilirsiniz",
  "ignore_notifications_modal.ignore": "Bildirimleri yoksay",
  "ignore_notifications_modal.limited_accounts_title": "Modere edilen hesapların bildirimlerini yoksay?",
  "ignore_notifications_modal.new_accounts_title": "Yeni hesapların bildirimlerini yoksay?",
  "ignore_notifications_modal.not_followers_title": "Takip etmeyen kişilerin bildirimlerini yoksay?",
  "ignore_notifications_modal.not_following_title": "Takip etmediğin kişilerin bildirimlerini yoksay?",
  "ignore_notifications_modal.private_mentions_title": "İstenmeyen özel bahsetmelerden gelen bildirimleri yoksay?",
  "info_button.label": "Yardım",
  "info_button.what_is_alt_text": "<h1>Alternatif metin nedir?</h1><p>Alternatif metin, görme bozukluğu olan, düşük bant genişliğine sahip bağlantıları olan veya ekstra bağlam arayan kişiler için görsel açıklamaları sağlar.</p><p>Net, sade ve nesnel alternatif metin yazarak herkes için erişilebilirliği ve anlaşılabilirliği iyileştirebilirsiniz.</p><ul><li>Önemlileri yakalayın</li><li>Resimlerdeki metni özetleyin</li><li>Düzenli cümle yapısı kullanın</li><li>Gereksiz bilgilerden kaçının</li><li>Karmaşık görsellerde (şemalar veya haritalar gibi) trendlere ve temel bulgulara odaklanın</li></ul>",
  "interaction_modal.action": "{name} kullanıcısının gönderisiyle etkileşim kurmak için, kullandığınız Mastodon sunucusunda hesabınıza giriş yapmanız gerekir.",
  "interaction_modal.action_follow": "{name}'i takip etmek için, kullandığınız Mastodon sunucusunda hesabınıza giriş yapmanız gerekir.",
  "interaction_modal.go": "Git",
  "interaction_modal.no_account_yet": "Henüz bir hesabınız yok mu?",
  "interaction_modal.on_another_server": "Farklı bir sunucuda",
  "interaction_modal.on_this_server": "Bu sunucuda",
  "interaction_modal.title": "Devam etmek için oturum açın",
  "interaction_modal.username_prompt": "Örnek: {example}",
  "intervals.full.days": "{number, plural, one {# gün} other {# gün}}",
  "intervals.full.hours": "{number, plural, one {# saat} other {# saat}}",
  "intervals.full.minutes": "{number, plural, one {# dakika} other {# dakika}}",
  "keyboard_shortcuts.back": "Geriye git",
  "keyboard_shortcuts.blocked": "Engellenen kullanıcılar listesini aç",
  "keyboard_shortcuts.boost": "Gönderiyi yeniden paylaş",
  "keyboard_shortcuts.column": "Sütunlardan birindeki duruma odaklanmak için",
  "keyboard_shortcuts.compose": "Yazma alanına odaklanmak için",
  "keyboard_shortcuts.description": "Açıklama",
  "keyboard_shortcuts.direct": "Özel bahsetmeler sütununu aç",
  "keyboard_shortcuts.down": "Listede aşağıya inmek için",
  "keyboard_shortcuts.enter": "Gönderiyi açınız",
  "keyboard_shortcuts.explore": "Öne çıkanlar zaman çizelgesini aç",
  "keyboard_shortcuts.favourite": "Gönderiyi favorilerine ekle",
  "keyboard_shortcuts.favourites": "Gözde listeni aç",
  "keyboard_shortcuts.federated": "Federe akışı aç",
  "keyboard_shortcuts.heading": "Klavye kısayolları",
  "keyboard_shortcuts.home": "Ana sayfa akışını aç",
  "keyboard_shortcuts.hotkey": "Kısayol tuşu",
  "keyboard_shortcuts.legend": "Bu efsaneyi görüntülemek için",
  "keyboard_shortcuts.load_more": "\"Daha fazlası\" düğmesine odaklan",
  "keyboard_shortcuts.local": "Yerel akışı aç",
  "keyboard_shortcuts.mention": "Yazana değinmek için",
  "keyboard_shortcuts.muted": "Sessize alınmış kullanıcı listesini açmak için",
  "keyboard_shortcuts.my_profile": "Profilinizi açmak için",
  "keyboard_shortcuts.notifications": "Bildirimler sütununu açmak için",
  "keyboard_shortcuts.open_media": "Medyayı açmak için",
  "keyboard_shortcuts.pinned": "Sabitlenmiş gönderilerin listesini aç",
  "keyboard_shortcuts.profile": "Yazanın profilini açmak için",
  "keyboard_shortcuts.quote": "Gönderiyi alıntıla",
  "keyboard_shortcuts.reply": "gönderiyi yanıtla",
  "keyboard_shortcuts.requests": "Takip istekleri listesini açmak için",
  "keyboard_shortcuts.search": "Aramaya odaklanmak için",
  "keyboard_shortcuts.spoilers": "CW alanını göstermek/gizlemek için",
  "keyboard_shortcuts.start": "\"başlarken\" sütununu açmak için",
  "keyboard_shortcuts.toggle_hidden": "CW'den önceki yazıyı göstermek/gizlemek için",
  "keyboard_shortcuts.toggle_sensitivity": "Medyayı göstermek/gizlemek için",
  "keyboard_shortcuts.toot": "Yeni bir gönderi başlat",
  "keyboard_shortcuts.top": "Listenin üstüne taşı",
  "keyboard_shortcuts.translate": "bir gönderiyi çevirmek için",
  "keyboard_shortcuts.unfocus": "Aramada bir gönderiye odaklanmamak için",
  "keyboard_shortcuts.up": "Listede yukarıya çıkmak için",
  "learn_more_link.got_it": "Anladım",
  "learn_more_link.learn_more": "Daha fazla bilgi edin",
  "lightbox.close": "Kapat",
  "lightbox.next": "Sonraki",
  "lightbox.previous": "Önceki",
  "lightbox.zoom_in": "Özgün boyuta dön",
  "lightbox.zoom_out": "Sığacak şekilde boyutla",
  "limited_account_hint.action": "Yine de profili göster",
  "limited_account_hint.title": "Bu profil {domain} moderatörleri tarafından gizlendi.",
  "link_preview.author": "Yazar: {name}",
  "link_preview.more_from_author": "{name} kişisinden daha fazlası",
  "link_preview.shares": "{count, plural, one {{counter} gönderi} other {{counter} gönderi}}",
  "lists.add_member": "Ekle",
  "lists.add_to_list": "Listeye ekle",
  "lists.add_to_lists": "{name} kişisini listelere ekle",
  "lists.create": "Oluştur",
  "lists.create_a_list_to_organize": "Ana sayfa akışınızı düzenlemek için yeni bir liste oluşturun",
  "lists.create_list": "Liste oluştur",
  "lists.delete": "Listeyi sil",
  "lists.done": "Tamamlandı",
  "lists.edit": "Listeleri düzenle",
  "lists.exclusive": "Ana sayfada üyeleri gizle",
  "lists.exclusive_hint": "Birisi bu listede yer alıyorsa, gönderilerini iki kez görmekten kaçınmak için onu ana sayfa akışınızda gizleyin.",
  "lists.find_users_to_add": "Eklenecek kullanıcıları bul",
  "lists.list_members_count": "{count, plural, one {# üye} other {# üye}}",
  "lists.list_name": "Liste adı",
  "lists.new_list_name": "Yeni liste adı",
  "lists.no_lists_yet": "Henüz liste yok.",
  "lists.no_members_yet": "Henüz üye yok.",
  "lists.no_results_found": "Sonuç bulunamadı.",
  "lists.remove_member": "Kaldır",
  "lists.replies_policy.followed": "Takip edilen herhangi bir kullanıcı",
  "lists.replies_policy.list": "Listenin üyeleri",
  "lists.replies_policy.none": "Hiç kimse",
  "lists.save": "Kaydet",
  "lists.search": "Ara",
  "lists.show_replies_to": "Liste üyelerinin yanıtlarını içer",
  "load_pending": "{count, plural, one {# yeni öğe} other {# yeni öğe}}",
  "loading_indicator.label": "Yükleniyor…",
  "media_gallery.hide": "Gizle",
  "moved_to_account_banner.text": "{disabledAccount} hesabınız, {movedToAccount} hesabına taşıdığınız için şu an devre dışı.",
  "mute_modal.hide_from_notifications": "Bildirimlerde gizle",
  "mute_modal.hide_options": "Seçenekleri gizle",
  "mute_modal.indefinite": "Ben sessizliklerini kaldırana kadar",
  "mute_modal.show_options": "Seçenekleri göster",
  "mute_modal.they_can_mention_and_follow": "Sizden bahsedebilir ve sizi takip edebilirler, ancak siz onları göremezsiniz.",
  "mute_modal.they_wont_know": "Susturulduklarını bilmeyecekler.",
  "mute_modal.title": "Kullanıcıyı sustur?",
  "mute_modal.you_wont_see_mentions": "Onlardan bahseden gönderiler göremezsiniz.",
  "mute_modal.you_wont_see_posts": "Onlar sizin gönderilerinizi görmeye devam edebilir, ancak siz onlarınkini göremezsiniz.",
  "navigation_bar.about": "Hakkında",
  "navigation_bar.account_settings": "Parola ve güvenlik",
  "navigation_bar.administration": "Yönetim",
  "navigation_bar.advanced_interface": "Gelişmiş web arayüzünde aç",
  "navigation_bar.automated_deletion": "Otomatik gönderi silme",
  "navigation_bar.blocks": "Engellenen kullanıcılar",
  "navigation_bar.bookmarks": "Yer İşaretleri",
  "navigation_bar.collections": "Koleksiyonlar",
  "navigation_bar.direct": "Özel bahsetmeler",
  "navigation_bar.domain_blocks": "Engellenen alan adları",
  "navigation_bar.favourites": "Favorilerin",
  "navigation_bar.filters": "Sessize alınmış kelimeler",
  "navigation_bar.follow_requests": "Takip istekleri",
  "navigation_bar.followed_tags": "Takip edilen etiketler",
  "navigation_bar.follows_and_followers": "Takip edilenler ve takipçiler",
  "navigation_bar.import_export": "İçe ve dışa aktarma",
  "navigation_bar.lists": "Listeler",
  "navigation_bar.live_feed_local": "Canlı akış (yerel)",
  "navigation_bar.live_feed_public": "Canlı akış (herkese açık)",
  "navigation_bar.logout": "Oturumu kapat",
  "navigation_bar.moderation": "Moderasyon",
  "navigation_bar.more": "Daha fazla",
  "navigation_bar.mutes": "Sessize alınmış kullanıcılar",
  "navigation_bar.opened_in_classic_interface": "Gönderiler, hesaplar ve diğer belirli sayfalar klasik web arayüzünde varsayılan olarak açılıyorlar.",
  "navigation_bar.preferences": "Tercihler",
  "navigation_bar.privacy_and_reach": "Gizlilik ve erişim",
  "navigation_bar.search": "Arama",
  "navigation_bar.search_trends": "Ara / Öne Çıkanlar",
  "navigation_panel.collapse_followed_tags": "Takip edilen etiketler menüsünü daralt",
  "navigation_panel.collapse_lists": "Liste menüsünü daralt",
  "navigation_panel.expand_followed_tags": "Takip edilen etiketler menüsünü genişlet",
  "navigation_panel.expand_lists": "Liste menüsünü genişlet",
  "not_signed_in_indicator.not_signed_in": "Bu kaynağa erişmek için oturum açmanız gerekir.",
  "notification.added_to_collection": "{name} sizi bir koleksiyona ekledi",
  "notification.admin.report": "{name}, {target} kişisini bildirdi",
  "notification.admin.report_account": "{name}, {category} kategorisi için {target} kişisini {count, plural, one {bir gönderi} other {# gönderi}} bildirdi",
  "notification.admin.report_account_other": "{name}, {target} kişisinden {count, plural, one {bir gönderi} other {# gönderi}} bildirdi",
  "notification.admin.report_statuses": "{name}, {category} kategorisi için {target} kişisini bildirdi",
  "notification.admin.report_statuses_other": "{name}, {target} kişisini bildirdi",
  "notification.admin.sign_up": "{name} kaydoldu",
  "notification.admin.sign_up.name_and_others": "{name} ve {count, plural, one {# diğer kişi} other {# diğer kişi}} kaydoldu",
  "notification.annual_report.message": "{year} yılı #Wrapstodon'unuz bekliyor! Yılınızın Mastodon'daki öne çıkanlarını ve anılarınızı gösterin!",
  "notification.annual_report.view": "#Wrapstodon'u Görüntüle",
  "notification.collection_update": "{name} olduğunuz bir koleksiyonu düzenledi",
  "notification.favourite": "{name} gönderinizi beğendi",
  "notification.favourite.name_and_others_with_link": "{name} ve <a>{count, plural, one {# diğer kişi} other {# diğer kişi}}</a> gönderinizi beğendi",
  "notification.favourite_pm": "{name} özel bahsetmenizi beğendi",
  "notification.favourite_pm.name_and_others_with_link": "{name} ve <a>{count, plural, one {# diğer kişi} other {# diğer kişi}}</a> özel değininizi beğendi",
  "notification.follow": "{name} seni takip etti",
  "notification.follow.name_and_others": "{name} ve <a>{count, plural, one {# diğer kişi} other {# diğer kişi}}</a> sizi takip etti",
  "notification.follow_request": "{name} size takip isteği gönderdi",
  "notification.follow_request.name_and_others": "{name} ve {count, plural, one {# diğer kişi} other {# diğer kişi}} size takip etme isteği gönderdi",
  "notification.label.mention": "Bahsetme",
  "notification.label.private_mention": "Özel bahsetme",
  "notification.label.private_reply": "Özel yanıt",
  "notification.label.quote": "{name} gönderini yeniden paylaştı",
  "notification.label.reply": "Yanıt",
  "notification.mention": "Bahsetme",
  "notification.mentioned_you": "{name} sizden söz etti",
  "notification.moderation-warning.learn_more": "Daha fazlası",
  "notification.moderation_warning": "Hesabınız bir denetim uyarısı aldı",
  "notification.moderation_warning.action_delete_statuses": "Bazı gönderileriniz kaldırıldı.",
  "notification.moderation_warning.action_disable": "Hesabınız devre dışı bırakıldı.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Bazı gönderileriniz hassas olarak işaretlendi.",
  "notification.moderation_warning.action_none": "Hesabınız bir denetim uyarısı aldı.",
  "notification.moderation_warning.action_sensitive": "Gönderileriniz artık hassas olarak işaretlenecek.",
  "notification.moderation_warning.action_silence": "Hesabınız sınırlandırıldı.",
  "notification.moderation_warning.action_suspend": "Hesabınız askıya alındı.",
  "notification.own_poll": "Anketiniz sona erdi",
  "notification.poll": "Oy verdiğiniz bir anket sona erdi",
  "notification.quoted_update": "{name} alıntıladığınız bir gönderiyi düzenledi",
  "notification.reblog": "{name} gönderini yeniden paylaştı",
  "notification.reblog.name_and_others_with_link": "{name} ve <a>{count, plural, one {# diğer kişi} other {# diğer kişi}}</a> gönderinizi yeniden paylaştı",
  "notification.relationships_severance_event": "{name} ile bağlantılar koptu",
  "notification.relationships_severance_event.account_suspension": "{from} yöneticisi, {target} askıya aldı, bunun anlamı onlardan artık güncelleme alamayacak veya etkileşemeyeceksiniz demektir.",
  "notification.relationships_severance_event.domain_block": "{from} yöneticisi {target} engelledi, {followersCount} takipçiniz ve takip ettiğiniz {followingCount, plural, one {# hesap} other {# hesap}} buna dahil.",
  "notification.relationships_severance_event.learn_more": "Daha fazlası",
  "notification.relationships_severance_event.user_domain_block": "{target} engellediniz, takipçilerinizden {followersCount} ve takip eden {followingCount, plural, one {# hesap} other {# hesap}} kaldırılıyor.",
  "notification.status": "{name} az önce gönderdi",
  "notification.update": "{name} bir gönderiyi düzenledi",
  "notification_requests.accept": "Onayla",
  "notification_requests.accept_multiple": "{count, plural, one {# isteği kabul et…} other {# isteği kabul et…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {İsteği kabul et} other {İstekleri kabul et}}",
  "notification_requests.confirm_accept_multiple.message": "{count, plural, one {Bir bildirim isteğini} other {# bildirim isteğini}} kabul etmek üzeresiniz. Devam etmek istediğinizden emin misiniz?",
  "notification_requests.confirm_accept_multiple.title": "Bildirim isteklerini kabul et?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {İsteği reddet} other {İstekleri reddet}}",
  "notification_requests.confirm_dismiss_multiple.message": "{count, plural, one {Bir bildirim isteğini} other {# bildirim isteğini}} reddetmek üzeresiniz. {count, plural, one {Ona} other {Onlara}} tekrar kolayca ulaşamayacaksınz. Devam etmek istediğinizden emin misiniz?",
  "notification_requests.confirm_dismiss_multiple.title": "Bildirim isteklerini reddet?",
  "notification_requests.dismiss": "Yoksay",
  "notification_requests.dismiss_multiple": "{count, plural, one {# isteği reddet…} other {# isteği reddet…}}",
  "notification_requests.edit_selection": "Düzenle",
  "notification_requests.exit_selection": "Tamamlandı",
  "notification_requests.explainer_for_limited_account": "Hesap bir moderatör tarafından sınırlandığı için, bu hesaptan gönderilen bildirimler filtrelendi.",
  "notification_requests.explainer_for_limited_remote_account": "Hesap veya sunucusu bir moderatör tarafından sınırlandığı için, bu hesaptan gönderilen bildirimler filtrelendi.",
  "notification_requests.maximize": "Büyüt",
  "notification_requests.minimize_banner": "Filtrelenmiş bildirimler başlığını küçült",
  "notification_requests.notifications_from": "{name} bildirimleri",
  "notification_requests.title": "Filtrelenmiş bildirimler",
  "notification_requests.view": "Bildirimleri görüntüle",
  "notifications.clear": "Bildirimleri temizle",
  "notifications.clear_confirmation": "Tüm bildirimlerinizi kalıcı olarak temizlemek ister misiniz?",
  "notifications.clear_title": "Bildirimleri temizle?",
  "notifications.column_settings.admin.report": "Yeni bildirimler:",
  "notifications.column_settings.admin.sign_up": "Yeni kayıtlar:",
  "notifications.column_settings.alert": "Masaüstü bildirimleri",
  "notifications.column_settings.favourite": "Favorilerin:",
  "notifications.column_settings.filter_bar.advanced": "Tüm kategorileri görüntüle",
  "notifications.column_settings.filter_bar.category": "Hızlı filtre çubuğu",
  "notifications.column_settings.follow": "Yeni takipçiler:",
  "notifications.column_settings.follow_request": "Yeni takip istekleri:",
  "notifications.column_settings.group": "Grupla",
  "notifications.column_settings.mention": "Bahsetmeler:",
  "notifications.column_settings.poll": "Anket sonuçları:",
  "notifications.column_settings.push": "Anlık bildirimler",
  "notifications.column_settings.quote": "Alıntılar:",
  "notifications.column_settings.reblog": "Yeniden paylaşanlar:",
  "notifications.column_settings.show": "Sütunda göster",
  "notifications.column_settings.sound": "Ses çal",
  "notifications.column_settings.status": "Yeni gönderiler:",
  "notifications.column_settings.unread_notifications.category": "Okunmamış bildirimler",
  "notifications.column_settings.unread_notifications.highlight": "Okunmamış bildirimleri öne çıkar",
  "notifications.column_settings.update": "Düzenlemeler:",
  "notifications.filter.all": "Tümü",
  "notifications.filter.boosts": "Yeniden paylaşımlar",
  "notifications.filter.favourites": "Favorilerin",
  "notifications.filter.follows": "Takip edilenler",
  "notifications.filter.mentions": "Bahsetmeler",
  "notifications.filter.polls": "Anket sonuçları",
  "notifications.filter.statuses": "Takip ettiğiniz kişilerden gelen güncellemeler",
  "notifications.grant_permission": "İzin ver.",
  "notifications.group": "{count} bildirim",
  "notifications.mark_as_read": "Her bildirimi okundu olarak işaretle",
  "notifications.permission_denied": "Daha önce reddedilen tarayıcı izinleri isteği nedeniyle masaüstü bildirimleri kullanılamıyor",
  "notifications.permission_denied_alert": "Tarayıcı izni daha önce reddedildiğinden, masaüstü bildirimleri etkinleştirilemez",
  "notifications.permission_required": "Masaüstü bildirimleri, gereksinim duyulan izin verilmediği için mevcut değil.",
  "notifications.policy.accept": "Kabul Et",
  "notifications.policy.accept_hint": "Bildirimlerde göster",
  "notifications.policy.drop": "Yoksay",
  "notifications.policy.drop_hint": "Boşluğa gönder, tekrar hiç görünmesin",
  "notifications.policy.filter": "Filtrele",
  "notifications.policy.filter_hint": "Filtreli bildirimleri kutusuna gönder",
  "notifications.policy.filter_limited_accounts_hint": "Sunucu moderatörleri tarafından kısıtlanmış",
  "notifications.policy.filter_limited_accounts_title": "Denetlenen hesaplar",
  "notifications.policy.filter_new_accounts.hint": "Son {days, plural, one {bir gün} other {# gün}}de oluşturuldu",
  "notifications.policy.filter_new_accounts_title": "Yeni hesaplar",
  "notifications.policy.filter_not_followers_hint": "Sizi {days, plural, one {bir gün} other {# gün}}den azdır takip eden kişileri de içeriyor",
  "notifications.policy.filter_not_followers_title": "Seni takip etmeyen kullanıcılar",
  "notifications.policy.filter_not_following_hint": "Onları manuel olarak onaylayana kadar",
  "notifications.policy.filter_not_following_title": "Takip etmediğin kullanıcılar",
  "notifications.policy.filter_private_mentions_hint": "Kendi değinmenize yanıt veya takip ettiğiniz kullanıcıdan değilse filtrelenir",
  "notifications.policy.filter_private_mentions_title": "İstenmeyen özel bahsetmeler",
  "notifications.policy.title": "Şundan bildirimleri yönet…",
  "notifications_permission_banner.enable": "Masaüstü bildirimlerini etkinleştir",
  "notifications_permission_banner.how_to_control": "Mastodon açık olmadığında bildirim almak için masaüstü bildirimlerini etkinleştirin. Etkinleştirildikten sonra, yukarıdaki{icon} düğmesi aracılığıyla hangi etkileşim türlerinin masaüstü bildirimi oluşturacağını tam olarak kontrol edebilirsiniz.",
  "notifications_permission_banner.title": "Hiçbir şeyi kaçırmayın",
  "onboarding.follows.back": "Geri",
  "onboarding.follows.empty": "Maalesef şu an bir sonuç gösterilemiyor. Takip edilecek kişileri bulmak için arama veya keşfet sayfasına gözatmayı kullanabilirsiniz veya daha sonra tekrar deneyin.",
  "onboarding.follows.next": "Sonraki: Profilinizi ayarlayın",
  "onboarding.follows.search": "Ara",
  "onboarding.follows.title": "Başlamak için insanları takip edin",
  "onboarding.profile.discoverable": "Profilimi keşfedilebilir yap",
  "onboarding.profile.discoverable_hint": "Mastodon'da keşfedilebilirliği etkinleştirdiğinizde, gönderileriniz arama sonuçlarında ve trendlerde görünebilir aynı zamanda profiliniz sizinle benzer ilgi alanlarına sahip kişilere önerilebilir.",
  "onboarding.profile.display_name": "Görünen isim",
  "onboarding.profile.display_name_hint": "Tam adınız veya kullanıcı adınız…",
  "onboarding.profile.finish": "Tamamla",
  "onboarding.profile.note": "Biyografi",
  "onboarding.profile.note_hint": "Diğer insanlara @değinebilir veya #etiketler kullanabilirsiniz…",
  "onboarding.profile.title": "Profilini ayarla",
  "onboarding.profile.upload_avatar": "Profil resmi yükle",
  "onboarding.profile.upload_header": "Profil başlığı yükle",
  "password_confirmation.exceeds_maxlength": "Parola onayı azami parola uzunluğunu aşıyor",
  "password_confirmation.mismatching": "Parola onayı eşleşmiyor",
  "picture_in_picture.restore": "Onu geri koy",
  "poll.closed": "Kapandı",
  "poll.refresh": "Yenile",
  "poll.reveal": "Sonuçları gör",
  "poll.total_people": "{count, plural, one {# kişi} other {# kişi}}",
  "poll.total_votes": "{count, plural, one {# oy} other {# oy}}",
  "poll.vote": "Oyla",
  "poll.voted": "Bu cevap için oy kullandınız",
  "poll.votes": "{votes, plural, one {# oy} other {# oy}}",
  "poll_button.add_poll": "Bir anket ekleyin",
  "poll_button.remove_poll": "Anketi kaldır",
  "privacy.change": "Gönderi gizliliğini değiştir",
  "privacy.direct.long": "Gönderide değinilen herkes",
  "privacy.direct.short": "Özel bahsetme",
  "privacy.private.long": "Sadece takipçileriniz",
  "privacy.private.short": "Takipçiler",
  "privacy.public.long": "Mastodon'da olan olmayan herkes",
  "privacy.public.short": "Herkese açık",
  "privacy.quote.anyone": "{visibility}, alıntı yapılabilir",
  "privacy.quote.disabled": "{visibility}, alıntı yapılamaz",
  "privacy.quote.limited": "{visibility}, sınırlı alıntı",
  "privacy.unlisted.additional": "Bu neredeyse herkese açık gibi çalışır, tek farkı gönderi canlı akışlarda veya etiketlerde, keşfette, veya Mastodon aramasında gözükmez, hesap çapında öyle seçmiş olsanız bile.",
  "privacy.unlisted.long": "Mastodon arama sonuçlarında, öne çıkanlarda ve herkese açık zaman çizelgesinde gizli",
  "privacy.unlisted.short": "Sessizce herkese açık",
  "privacy_policy.last_updated": "Son güncelleme {date}",
  "privacy_policy.title": "Gizlilik Politikası",
  "quote_error.edit": "Gönderi düzenlenirken alıntılar eklenemez.",
  "quote_error.poll": "Anketlerde alıntıya izin verilmez.",
  "quote_error.private_mentions": "Doğrudan atıfta bulunarak alıntı yapma izni yoktur.",
  "quote_error.quote": "Bir seferde tek bir alıntıya izin var.",
  "quote_error.unauthorized": "Bu gönderiyi alıntılamaya yetkiniz yok.",
  "quote_error.upload": "Medya eklentilerini alıntılamaya izin yok.",
  "recommended": "Önerilen",
  "refresh": "Yenile",
  "regeneration_indicator.please_stand_by": "Lütfen bekleyin.",
  "regeneration_indicator.preparing_your_home_feed": "Ana akışınız hazırlanıyor…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# gün} other {# gün}} önce",
  "relative_time.full.hours": "{number, plural, one {# saat} other {# saat}} önce",
  "relative_time.full.just_now": "şimdi",
  "relative_time.full.minutes": "{number, plural, one {# dakika} other {# dakika}} önce",
  "relative_time.full.seconds": "{number, plural, one {# saniye} other {# saniye}} önce",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "şimdi",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}sn",
  "relative_time.today": "bugün",
  "remove_quote_hint.button_label": "Anladım",
  "remove_quote_hint.message": "Bunu {icon} seçenekler menüsünden yapabilirsiniz.",
  "remove_quote_hint.title": "Alıntılanmış gönderinizi kaldırmak mı istiyorsunuz?",
  "reply_indicator.attachments": "{count, plural, one {# ek} other {# ek}}",
  "reply_indicator.cancel": "İptal",
  "reply_indicator.poll": "Anket",
  "report.block": "Engelle",
  "report.block_explanation": "Gönderilerini göremeyeceksiniz. Gönderilerinizi göremezler veya sizi takip edemezler. Engelli olduklarını anlayabilecekler.",
  "report.categories.legal": "Yasal",
  "report.categories.other": "Diğer",
  "report.categories.spam": "İstenmeyen",
  "report.categories.violation": "İçerik bir veya daha fazla sunucu kuralını ihlal ediyor",
  "report.category.subtitle": "En uygun eşleşmeyi seçin",
  "report.category.title": "Bu {type} ile ilgili neler oluyor bize söyleyin",
  "report.category.title_account": "profil",
  "report.category.title_status": "gönderi",
  "report.close": "Tamam",
  "report.collection_comment": "Bu koleksiyonu neden bildirmek istiyorsunuz?",
  "report.comment.title": "Bilmemizi istediğiniz başka bir şey var mı?",
  "report.forward": "{target} ilet",
  "report.forward_hint": "Hesap başka bir sunucudan. Raporun anonim bir kopyası da oraya gönderilsin mi?",
  "report.mute": "Sessiz",
  "report.mute_explanation": "Gönderilerini göremeyeceksiniz. Sizi takip etmeyi sürdürebilir ve gönderilerinizi görebilirler ama sessize alındıklarını anlamayacaklar.",
  "report.next": "Sonraki",
  "report.placeholder": "Ek yorumlar",
  "report.reasons.dislike": "Hoşlanmadım",
  "report.reasons.dislike_description": "Görmek isteyeceğiniz bir şey değil",
  "report.reasons.legal": "Bu yasalara aykırı",
  "report.reasons.legal_description": "Kendi veya sunucunuzun ülkesinin yasalarını ihlal ettiğini düşünüyorsunuz",
  "report.reasons.other": "Başka bir şey",
  "report.reasons.other_description": "Sorun başka kategorilere uymuyor",
  "report.reasons.spam": "İstenmeyen",
  "report.reasons.spam_description": "Kötü niyetli bağlantılar, sahte etkileşim veya tekrarlayan yanıtlar",
  "report.reasons.violation": "Sunucu kurallarını ihlal ediyor",
  "report.reasons.violation_description": "Belirli kuralları ihlal ettiğinin farkındasınız",
  "report.rules.subtitle": "Geçerli olanların hepsini seçin",
  "report.rules.title": "Hangi kurallar ihlal ediliyor?",
  "report.statuses.subtitle": "Geçerli olanların hepsini seçin",
  "report.statuses.title": "Bu bildirimi destekleyecek herhangi bir gönderi var mı?",
  "report.submission_error": "Bildirim gönderilemiyor",
  "report.submission_error_details": "Lütfen ağ durumunu kontrol edin ve daha sonra tekrar deneyin.",
  "report.submit": "Gönder",
  "report.target": "{target} Bildiriliyor",
  "report.thanks.take_action": "Mastodon'da ne görebileceğinizi denetlemeye ilişkin seçenekler şunlardır:",
  "report.thanks.take_action_actionable": "Biz değerlendirirken, @{name} hesabına yönelik bir şeyler yapabilirsiniz:",
  "report.thanks.title": "Bunu görmek istemiyor musunuz?",
  "report.thanks.title_actionable": "Bildirdiğiniz için teşekkürler, konuyu araştıracağız.",
  "report.unfollow": "@{name} takip etmeyi bırak",
  "report.unfollow_explanation": "Bu hesabı takip ediyorsunuz. Ana akışınızda gönderilerini görmek istemiyorsanız, onu takip etmeyi bırakın.",
  "report_notification.attached_statuses": "{count, plural, one {{count} gönderi} other {{count} gönderi}} eklendi",
  "report_notification.categories.legal": "Yasal",
  "report_notification.categories.legal_sentence": "yasadışı içerik",
  "report_notification.categories.other": "Diğer",
  "report_notification.categories.other_sentence": "diğer",
  "report_notification.categories.spam": "İstenmeyen",
  "report_notification.categories.spam_sentence": "i̇stenmeyen",
  "report_notification.categories.violation": "Kural ihlali",
  "report_notification.categories.violation_sentence": "kural ihlali",
  "report_notification.open": "Bildirim aç",
  "search.clear": "Aramayı temizle",
  "search.no_recent_searches": "Son arama yok",
  "search.placeholder": "Ara",
  "search.quick_action.account_search": "Eşleşen profiller {x}",
  "search.quick_action.go_to_account": "Profile git {x}",
  "search.quick_action.go_to_hashtag": "Etikete git {x}",
  "search.quick_action.open_url": "Bağlantıyı Mastodon'da Aç",
  "search.quick_action.status_search": "Eşleşen gönderiler {x}",
  "search.search_or_paste": "Ara veya bağlantıyı yapıştır",
  "search_popout.full_text_search_disabled_message": "{domain} sunucusunda mevcut değil.",
  "search_popout.full_text_search_logged_out_message": "Sadece oturum açıldığında mevcuttur.",
  "search_popout.language_code": "ISO dil kodu",
  "search_popout.options": "Arama seçenekleri",
  "search_popout.quick_actions": "Hızlı eylemler",
  "search_popout.recent": "Son aramalar",
  "search_popout.specific_date": "belirli tarih",
  "search_popout.user": "kullanıcı",
  "search_results.accounts": "Profiller",
  "search_results.all": "Tümü",
  "search_results.hashtags": "Etiketler",
  "search_results.no_results": "Sonuç yok.",
  "search_results.no_search_yet": "Gönderiler, profiller veya etiketler için aramayı deneyin.",
  "search_results.see_all": "Tümünü gör",
  "search_results.statuses": "Gönderiler",
  "search_results.title": "\"{q}\" için arama",
  "server_banner.about_active_users": "Bu sunucuyu son 30 günde kullanan insanlar (Aylık Etkin Kullanıcılar)",
  "server_banner.active_users": "etkin kullanıcılar",
  "server_banner.administered_by": "Yönetici:",
  "server_banner.is_one_of_many": "{domain} fediverse katılımı için kullanabileceğiniz birçok bağımsız Mastodon sunucusundan biridir.",
  "server_banner.more_about_this_server": "Bu sunucu hakkında daha fazla bilgi",
  "server_banner.server_stats": "Sunucu istatistikleri:",
  "sign_in_banner.create_account": "Hesap oluştur",
  "sign_in_banner.follow_anyone": "Fediverse çapında herhangi bir kimseyi takip edin ve tümünü kronolojik sırada görüntüleyin. Algoritma, reklam veya tıklama tuzağı yok.",
  "sign_in_banner.mastodon_is": "Neler olup bittiğini izlemenin en iyi aracı Mastodon'dur.",
  "sign_in_banner.sign_in": "Giriş yap",
  "sign_in_banner.sso_redirect": "Giriş yap veya kaydol",
  "skip_links.hotkey": "<span>Kısayol tuşu</span> {hotkey}",
  "skip_links.skip_to_content": "Ana içeriğe git",
  "skip_links.skip_to_navigation": "Ana gezinmeye git",
  "status.admin_account": "@{name} için denetim arayüzünü açın",
  "status.admin_domain": "{domain} için denetim arayüzünü açın",
  "status.admin_status": "Denetim arayüzünde bu gönderiyi açın",
  "status.all_disabled": "Yükseltmeler ve alıntılar devre dışı bırakıldı",
  "status.block": "@{name} adlı kişiyi engelle",
  "status.bookmark": "Yer işareti ekle",
  "status.cancel_reblog_private": "Yeniden paylaşımı geri al",
  "status.cannot_quote": "Bu gönderiyi alıntılamaya izniniz yok",
  "status.cannot_reblog": "Bu gönderi yeniden paylaşılamaz",
  "status.contains_quote": "Alıntı içeriyor",
  "status.context.loading": "Daha fazla yanıt yükleniyor",
  "status.context.loading_error": "Yeni yanıtlar yüklenemiyor",
  "status.context.loading_success": "Yeni yanıtlar yüklendi",
  "status.context.more_replies_found": "Daha fazla yanıt bulundu",
  "status.context.retry": "Yeniden dene",
  "status.context.show": "Göster",
  "status.continued_thread": "Devam eden akış",
  "status.copy": "Gönderi bağlantısını kopyala",
  "status.delete": "Sil",
  "status.delete.success": "Gönderi silindi",
  "status.detailed_status": "Ayrıntılı sohbet görünümü",
  "status.direct": "@{name} kullanıcısına özelden değin",
  "status.direct_indicator": "Özel değinme",
  "status.edit": "Düzenle",
  "status.edited": "Son düzenleme {date}",
  "status.edited_x_times": "{count, plural, one {{count} kez} other {{count} kez}} düzenlendi",
  "status.embed": "Gömme kodunu al",
  "status.favourite": "Favori",
  "status.favourites_count": "{count, plural, one {{counter} favori} other {{counter} favori}}",
  "status.filter": "Bu gönderiyi süzgeçle",
  "status.history.created": "{name} oluşturdu {date}",
  "status.history.edited": "{name} düzenledi {date}",
  "status.load_more": "Daha fazlası",
  "status.media.open": "Açmak için tıklayın",
  "status.media.show": "Göstermek için tıklayın",
  "status.media_hidden": "Medya gizli",
  "status.mention": "@{name} kişisinden bahset",
  "status.more": "Daha fazla",
  "status.mute": "@{name} kişisini sessize al",
  "status.mute_conversation": "Sohbeti sessize al",
  "status.open": "Bu gönderiyi genişlet",
  "status.pin": "Profile sabitle",
  "status.quote": "Teklif",
  "status.quote.cancel": "Teklifi iptal et",
  "status.quote_error.blocked_account_hint.title": "Bu gönderi @{name} kişisini engellediğiniz için gizlenmiştir.",
  "status.quote_error.blocked_domain_hint.title": "Bu gönderi {domain} adresini engellediğiniz için gizlenmiştir.",
  "status.quote_error.filtered": "Bazı filtrelerinizden dolayı gizlenmiştir",
  "status.quote_error.limited_account_hint.action": "Yine de göster",
  "status.quote_error.limited_account_hint.title": "Bu hesap {domain} moderatörleri tarafından gizlendi.",
  "status.quote_error.muted_account_hint.title": "Bu gönderi @{name} kişisini sessize aldığınız için gizlenmiştir.",
  "status.quote_error.not_available": "Gönderi kullanılamıyor",
  "status.quote_error.pending_approval": "Gönderi beklemede",
  "status.quote_error.pending_approval_popout.body": "Mastodon'da, birinin sizi alıntılayıp alıntılayamayacağını kontrol edebilirsiniz. Bu gönderi, orijinal yazarın onayını alma sürecinde beklemede.",
  "status.quote_error.revoked": "Gönderi yazarı tarafından kaldırıldı",
  "status.quote_followers_only": "Sadece takipçiler bu gönderiyi alıntılayabilir",
  "status.quote_manual_review": "Yazar manuel olarak gözden geçirecek",
  "status.quote_noun": "Alıntı",
  "status.quote_policy_change": "Kimin alıntı yapabileceğini değiştirin",
  "status.quote_post_author": "@{name} adlı kullanıcının bir gönderisini alıntıladı",
  "status.quote_private": "Özel gönderiler alıntılanamaz",
  "status.quotes.empty": "Henüz hiç kimse bu gönderiyi alıntılamadı. Herhangi bir kullanıcı alıntıladığında burada görüntülenecek.",
  "status.quotes.local_other_disclaimer": "Yazar tarafından reddedilen alıntılar gösterilmez.",
  "status.quotes.remote_other_disclaimer": "Yalnızca {domain} adresinden gelen alıntılar burada gösterilir. Yazar tarafından reddedilen alıntılar gösterilmez.",
  "status.quotes_count": "{count, plural, one {{counter} alıntı} other {{counter} alıntı}}",
  "status.read_more": "Devamını okuyun",
  "status.reblog": "Yeniden paylaş",
  "status.reblog_or_quote": "Yükselt veya alıntıla",
  "status.reblog_private": "Takipçilerinizle tekrar paylaşın",
  "status.reblogged_by": "{name} yeniden paylaştı",
  "status.reblogs.empty": "Henüz hiç kimse bu gönderiyi yeniden paylaşmadı. Herhangi bir kullanıcı yeniden paylaştığında burada görüntülenecek.",
  "status.reblogs_count": "{count, plural, one {{counter} yeniden paylaşım} other {{counter} yeniden paylaşım}}",
  "status.redraft": "Sil,Düzenle ve yeniden-paylaş",
  "status.remove_bookmark": "Yer işaretini kaldır",
  "status.remove_favourite": "Favorilerden kaldır",
  "status.remove_quote": "Kaldır",
  "status.replied_in_thread": "Akışta yanıtlandı",
  "status.replied_to": "{name} kullanıcısına yanıt verdi",
  "status.reply": "Yanıtla",
  "status.replyAll": "Konuyu yanıtla",
  "status.report": "@{name} adlı kişiyi bildir",
  "status.request_quote": "Alıntılamayı iste",
  "status.revoke_quote": "@{name} kullanıcısının gönderisinden benim gönderimi kaldır",
  "status.sensitive_warning": "Hassas içerik",
  "status.share": "Paylaş",
  "status.show_less_all": "Hepsi için daha az göster",
  "status.show_more_all": "Hepsi için daha fazla göster",
  "status.show_original": "Özgün içeriği göster",
  "status.title.with_attachments": "{user}, {attachmentCount, plural, one {1 ek} other {{attachmentCount} ek}} gönderdi",
  "status.translate": "Çevir",
  "status.translated_from_with": "{provider} kullanılarak {lang} dilinden çevrildi",
  "status.uncached_media_warning": "Ön izleme mevcut değil",
  "status.unmute_conversation": "Sohbet sesini aç",
  "status.unpin": "Profilden sabitlemeyi kaldır",
  "subscribed_languages.lead": "Değişiklikten sonra ana akışınızda sadece seçili dillerdeki gönderiler görüntülenecek ve zaman akışları listelenecektir. Tüm dillerde gönderiler için hiçbirini seçin.",
  "subscribed_languages.save": "Değişiklikleri kaydet",
  "subscribed_languages.target": "{target} abone olduğu dilleri değiştir",
  "tabs_bar.home": "Ana sayfa",
  "tabs_bar.menu": "Menü",
  "tabs_bar.notifications": "Bildirimler",
  "tabs_bar.publish": "Yeni Gönderi",
  "tabs_bar.search": "Arama",
  "tag.remove": "Kaldır",
  "terms_of_service.effective_as_of": "{date} itibariyle yürürlükte",
  "terms_of_service.title": "Hizmet Şartları",
  "terms_of_service.upcoming_changes_on": "{date} tarihinde gerçekleşecek değişiklikler",
  "time_remaining.days": "{number, plural, one {# gün} other {# gün}} kaldı",
  "time_remaining.hours": "{number, plural, one {# saat} other {# saat}} kaldı",
  "time_remaining.minutes": "{number, plural, one {# dakika} other {# dakika}} kaldı",
  "time_remaining.moments": "Sadece birkaç dakika kaldı",
  "time_remaining.seconds": "{number, plural, one {# saniye} other {# saniye}} kaldı",
  "trends.counter_by_accounts": "Son {days, plural, one {gündeki} other {{days} gündeki}} {count, plural, one {{counter} kişi} other {{counter} kişi}}",
  "trends.trending_now": "Şu an gündemde",
  "ui.beforeunload": "Mastodon'u terk ederseniz taslağınız kaybolacak.",
  "units.short.billion": "{count}Mr",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}Bin",
  "upload_area.title": "Karşıya yükleme için sürükle bırak yapınız",
  "upload_button.label": "Resim, video veya ses dosyası ekleyin",
  "upload_error.limit": "Dosya yükleme sınırı aşıldı.",
  "upload_error.poll": "Anketlerde dosya yüklemesine izin verilmez.",
  "upload_error.quote": "Anketlerde dosya yüklemesine izin verilmez.",
  "upload_form.drag_and_drop.instructions": "Bir medya eklentisini taşımak için, boşluk veya enter tuşuna basın. Sürükleme sırasında medya eklentisini herhangi bir yöne hareket ettirmek için ok tuşlarını kullanın. Medya eklentisini yeni konumuna bırakmak için tekrar boşluk veya enter tuşuna basın veya işlemi iptal etmek için escape tuşuna basın.",
  "upload_form.drag_and_drop.on_drag_cancel": "Sürükleme iptal edildi. Medya eklentisi {item} bırakıldı.",
  "upload_form.drag_and_drop.on_drag_end": "Medya eklentisi {item} bırakıldı.",
  "upload_form.drag_and_drop.on_drag_over": "Medya eklentisi {item} hareket ettirildi.",
  "upload_form.drag_and_drop.on_drag_start": "Medya eklentisi {item} tutuldu.",
  "upload_form.edit": "Düzenle",
  "upload_progress.label": "Yükleniyor...",
  "upload_progress.processing": "İşleniyor…",
  "username.taken": "Bu kullanıcı adı alınmış. Farklı bir tane deneyin",
  "video.close": "Videoyu kapat",
  "video.download": "Dosyayı indir",
  "video.exit_fullscreen": "Tam ekrandan çık",
  "video.expand": "Videoyu genişlet",
  "video.fullscreen": "Tam ekran",
  "video.hide": "Videoyu gizle",
  "video.mute": "Sessiz",
  "video.pause": "Duraklat",
  "video.play": "Oynat",
  "video.skip_backward": "Geriye atla",
  "video.skip_forward": "İleriye atla",
  "video.unmute": "Sesi aç",
  "video.volume_down": "Sesi kıs",
  "video.volume_up": "Sesi yükselt",
  "visibility_modal.button_title": "Görünürlüğü ayarla",
  "visibility_modal.direct_quote_warning.text": "Mevcut ayarları kaydederseniz, gömülü alıntı bir bağlantıya dönüştürülür.",
  "visibility_modal.direct_quote_warning.title": "Alıntılar özel bahsetmelere eklenemez",
  "visibility_modal.header": "Görünürlük ve etkileşim",
  "visibility_modal.helper.direct_quoting": "Mastodon'da özel değiniler başkaları tarafından alıntılanamaz.",
  "visibility_modal.helper.privacy_editing": "Gönderi yayınlandıktan sonra görünürlük değiştirilemez.",
  "visibility_modal.helper.privacy_private_self_quote": "Özel mesajların kendi kendine alıntılanması herkese açık hale getirilemez.",
  "visibility_modal.helper.private_quoting": "Mastodon'da sadece takipçilere yönelik gönderiler başkaları tarafından alıntılanamaz.",
  "visibility_modal.helper.unlisted_quoting": "İnsanlar sizden alıntı yaptığında, onların gönderileri de trend zaman tünellerinden gizlenecektir.",
  "visibility_modal.instructions": "Bu gönderiyle kimlerin etkileşime girebileceğini kontrol edin. Ayrıca, <link>Tercihler > Gönderme varsayılanları</link> bölümüne giderek tüm gelecek gönderiler için ayarlayabilirsiniz.",
  "visibility_modal.privacy_label": "Görünürlük",
  "visibility_modal.quote_followers": "Sadece takipçiler",
  "visibility_modal.quote_label": "Kimler alıntılayabilir",
  "visibility_modal.quote_nobody": "Sadece ben",
  "visibility_modal.quote_public": "Herkesten",
  "visibility_modal.save": "Kaydet"
}
